{
 "ascending aorta": "أبهر صاعد",
 "arch of aorta": "قوس الأبهر",
 "descending aorta": "أبهر نازل",
 "abdominal aorta": "أبهر بطني",
 "right conus artery": "الفرع المخروطي للشريان التاجي الأيمن",
 "marginal branch of right coronary artery": "الفرع الهامشي الأيمن للشريان التاجي الأيمن",
 "posterior interventricular branch of right coronary artery": "الفرع بين البطيني الخلفي للشريان التاجي الأيمن",
 "circumflex branch of left coronary artery": "الشعبة المنعطفة من الشريان الإكليلي الأيسر",
 "brachiocephalic artery": "شريان عضدي رأسي",
 "common carotid artery": "شريان سباتي أصلي",
 "right common carotid artery": "شريان سباتي أصلي أيمن",
 "internal carotid artery": "شريان سباتي باطن",
 "subclavian artery": "شريان تحت الترقوة",
 "right subclavian artery": "شريان تحت الترقوة أيمن",
 "vertebral artery": "شريان فقري",
 "internal thoracic artery": "شريان صدري غائر",
 "thyrocervical trunk": "الجذع الدرقي الرقبي",
 "left common carotid artery": "شريان سباتي أصلي أيسر",
 "esophageal artery": "شريان مريئي",
 "subcostal artery": "شرايين تحت الضلع",
 "left subclavian artery": "شريان تحت الترقوة أيسر",
 "coronary sinus": "الجيب التاجي",
 "great cardiac vein": "وريد قلبي كبير",
 "left marginal vein": "وريد هامشي أيسر",
 "posterior vein of left ventricle": "وريد خلفي للبطين الأيسر",
 "middle cardiac vein": "وريد قلبي أوسط",
 "small cardiac vein": "وريد قلبي صغير",
 "right marginal vein": "وريد هامشي أيمن",
 "superior vena cava": "الوريد الأجوف العلوي",
 "brachiocephalic vein": "وريد عضدي رأسي",
 "internal jugular vein": "وريد وداجي باطن",
 "subclavian vein": "وريد تحت ترقوة",
 "internal thoracic vein": "وريد صدري غائر",
 "azygos vein": "وريد فرد",
 "hemiazygos vein": "الوريد ردف الفرد",
 "accessory hemiazygos vein": "الوريد ردف الفرد الإضافي",
 "bone organ": "عظم",
 "muscle organ": "عضلة",
 "cranial nerve": "أعصاب قحفية",
 "ganglion": "عقدة",
 "autonomic ganglion": "عقدة مستقلية",
 "parasympathetic ganglion": "عقدة لاودية",
 "ciliary ganglion": "عقدة هدبية",
 "esophagus": "مريء",
 "stomach": "معدة",
 "skin": "جلد",
 "spleen": "طحال",
 "pancreas": "بنكرياس",
 "gallbladder": "المرارة",
 "kidney": "كلية",
 "duodenum": "الاثنا عشر",
 "testis": "خصية",
 "trachea": "قصبة هوائية",
 "left main bronchus": "قصبة رئيسية يسرى",
 "main bronchus": "القصبة الرئيسية",
 "bronchus": "شعبة هوائية",
 "long bone": "عظم طويل",
 "short bone": "عظم قصير",
 "flat bone": "عظم مسطح",
 "irregular bone": "عظام غير منتظمة",
 "manubrium": "قبضة القص",
 "xiphoid process": "ناتئ رهابي",
 "rib": "ضلع",
 "costal cartilage": "غضروف ضلعي",
 "pulmonary trunk": "الجذع الرئوي",
 "thoracic vertebra": "فقرة صدرية",
 "salivary gland": "غدة لعابية",
 "prostate": "بروستات",
 "adrenal gland": "غدة كظرية",
 "femur": "عظم الفخذ",
 "metacarpal bone": "مشط اليد",
 "parietal bone": "عظم جداري",
 "cricoid cartilage": "الغضروف الحلقي",
 "muscle of head": "عضلة رأسية",
 "muscle of lower limb": "عضلات الطرف السفلي",
 "stylohyoid": "عضلة إبرية لامية",
 "supraspinatus": "عضلة فوق الشوكة",
 "portion of tissue": "نسيج حيوي",
 "anatomical line": "خط تشريحي",
 "nasolacrimal duct": "قناة أنفية دمعية",
 "ureter": "الحالب",
 "bile duct": "قناة الصفراء",
 "talus": "عظم الكاحل",
 "vomer": "الميكعة",
 "maxilla": "الفك العلوي",
 "tendon": "وتر",
 "internal intercostal muscle": "عضلات بين ضلعية غائرة",
 "transversus thoracis": "العضلة المستعرضة الصدرية",
 "vertebra": "فقرة",
 "cervical vertebra": "فقرة عنقية",
 "lumbar vertebra": "فقرة قطنية",
 "pancreatic duct": "قناة البنكرياس",
 "intervertebral disk": "القرص بين الفقرات",
 "costocervical trunk": "جذع ضلعي رقبي",
 "superior epigastric artery": "شريان شرسوفي علوي",
 "deep cervical artery": "شريان رقبي عميق",
 "inferior thyroid artery": "الشريان الدرقي السفلي",
 "suprascapular artery": "شريان فوق الكتف",
 "transverse cervical artery": "شريان رقبي مستعرض",
 "superficial cervical artery": "الفرع الظاهر للشريان الرقبي المستعرض",
 "inferior vena cava": "الوريد الأجوف السفلي",
 "linea alba": "الخط الأبيض",
 "ileocecal junction": "الموصل اللفائفي الأعوري",
 "tooth": "سن",
 "atlas": "فهقة",
 "axis": "محور",
 "incisor tooth": "قاطعة",
 "subcostal vein": "وريد تحت الضلع",
 "ascending lumbar vein": "وريد قطني صاعد",
 "pectoralis minor": "عضلة صدرية صغيرة",
 "diaphragm": "حجاب حاجز",
 "humerus": "عظم العضد",
 "clavicle": "ترقوة",
 "cephalic vein": "وريد رأسي",
 "axillary vein": "وريد إبطي",
 "external oblique": "عضلة مائلة خارجية",
 "sternohyoid": "عضلة قصية لامية",
 "omohyoid": "عضلة كتفية لامية",
 "sternothyroid": "عضلة قصية درقية",
 "thyrohyoid": "عضلة درقية لامية",
 "intercostal muscle": "عضلات بين ضلعية",
 "caudate lobe of liver": "الفص المذنب الكبدي",
 "rhomboid major": "عضلة معينية كبيرة",
 "rhomboid minor": "عضلة معينية صغيرة",
 "scalenus anterior": "الأخمعية الأمامية",
 "scalenus medius": "العضلة الأخمعية المتوسطة",
 "scapula": "لوح الكتف",
 "serratus anterior": "عضلة منشارية أمامية",
 "sternocleidomastoid": "عضلة قصية ترقوية حلمية",
 "subclavius": "عضلة تحت ترقوية",
 "subscapularis": "عضلة تحت الكتف",
 "pituitary gland": "غدة نخامية",
 "ventricular branch of right coronary artery": "الفرع البطيني للشريان التاجي الأيمن",
 "suprascapular vein": "الوريد فوق الكتف",
 "splenic vein": "وريد طحالي",
 "superior mesenteric vein": "وريد مساريقي علوي",
 "common iliac vein": "وريد حرقفي أصلي",
 "renal vein": "وريد كلوي",
 "hepatic vein": "وريد كبدي",
 "testicular vein": "وريد خصوي",
 "suprarenal vein": "وريد كظري",
 "cystic duct": "قناة المرارة",
 "appendix": "زائدة دودية",
 "rectum": "المستقيم",
 "ascending colon": "قولون صاعد",
 "transverse colon": "قولون مستعرض",
 "descending colon": "قولون نازل",
 "common hepatic duct": "قناة كبدية",
 "inferior phrenic artery": "شريان حجابي سفلي",
 "superior mesenteric artery": "الشريان المساريقي العلوي",
 "inferior mesenteric artery": "الشريان المساريقي السفلي",
 "renal artery": "شريان كلوي",
 "middle suprarenal artery": "شرايين وسطى كظرية",
 "testicular artery": "شريان خصوي",
 "common iliac artery": "شريان حرقفي أصلي",
 "left gastric artery": "شريان معدي أيسر",
 "common hepatic artery": "شريان كبدي أصلي",
 "hepatic artery proper": "شريان كبدي مخصوص",
 "splenic artery": "الشريان الطحالي",
 "right gastric artery": "شريان معدي أيمن",
 "right gastro-epiploic artery": "شريان معدي ثربي أيمن",
 "anterior superior pancreaticoduodenal artery": "شريان بنكرياسي إثنا عشري علوي أمامي",
 "posterior superior pancreaticoduodenal artery": "شريان بنكرياسي إثنا عشري علوي خلفي",
 "dorsal pancreatic artery": "شريان بنكرياسي ظهراني",
 "great pancreatic artery": "شريان بنكرياسي كبير",
 "left gastro-epiploic artery": "شريان معدي ثربي أيسر",
 "inferior pancreaticoduodenal artery": "شريان بنكرياسي اثنا عشري سفلي",
 "middle colic artery": "شريان قولوني أوسط",
 "right colic artery": "شريان قولوني أيمن",
 "ileocolic artery": "شريان لفائفي قولوني",
 "anterior cecal artery": "شريان أعوري أمامي",
 "posterior cecal artery": "شريان أعوري خلفي",
 "appendicular artery": "شريان زائدي",
 "ileal branch of inferior branch of ileocolic artery": "فرع لفائفي من شريان لفائفي قولوني",
 "ascending branch of inferior branch of ileocolic artery": "فرع قولوني للشريان اللفائفي القولوني",
 "marginal colic artery": "شريان القولون الهامشي",
 "left colic artery": "شريان قولوني أيسر",
 "ascending branch of left colic artery": "الفرع الصاعد للشريان القولوني الأيسر",
 "descending branch of left colic artery": "الفرع النازل للشريان القولوني الأيسر",
 "sigmoid artery": "شريان سيني",
 "superior rectal artery": "شريان مستقيمي علوي",
 "left gastroepiploic vein": "وريد معدي ثربي أيسر",
 "inferior mesenteric vein": "وريد مساريقي سفلي",
 "superior rectal vein": "وريد مستقيمي علوي",
 "left colic vein": "وريد قولوني أيسر",
 "right gastroepiploic vein": "وريد معدي ثربي أيمن",
 "left gastric vein": "وريد معدي أيسر",
 "right gastric vein": "وريد معدي أيمن",
 "middle colic vein": "وريد قولوني أوسط",
 "right colic vein": "وريد قولوني أيمن",
 "ileocolic vein": "وريد قولوني لفائفي",
 "urinary bladder": "مثانة",
 "sacrum": "العجز",
 "hip bone": "عظم الورك",
 "psoas major": "عضلة قطنية كبيرة",
 "glans penis": "حشفة القضيب",
 "epididymis": "بربخ",
 "external iliac artery": "شريان حرقفي ظاهر",
 "internal iliac artery": "شريان حرقفي غائر",
 "external iliac vein": "وريد حرقفي ظاهر",
 "internal iliac vein": "وريد حرقفي غائر",
 "iliolumbar vein": "وريد حرقفي قطني",
 "internal pudendal vein": "وريد فرجي غائر",
 "piriformis": "عضلة كمثرية",
 "coccygeus": "عضلة عصعصية",
 "pubococcygeus": "عضلات كيجل",
 "deferent duct": "أسهر",
 "seminal vesicle": "حويصلة منوية",
 "corpus spongiosum of penis": "الجسم الإسفنجي للقضيب",
 "corpus cavernosum of penis": "جسم كهفي للقضيب",
 "urethra": "إحليل",
 "loose connective tissue": "نسيج ضام رخو",
 "dorsal artery of penis": "شريان قضيبي ظهراني",
 "lacrimal sac": "كيس الدمع",
 "inferior epigastric artery": "شريان شرسوفي سفلي",
 "superficial epigastric artery": "شريان شرسوفي سطحي",
 "lateral circumflex femoral artery": "شريان فخذي منعطف وحشي",
 "inferior epigastric vein": "وريد شرسوفي سفلي",
 "femoral vein": "وريد فخذي",
 "great saphenous vein": "وريد صافن كبير",
 "external anal sphincter": "عاصرة شرجية خارجية",
 "obturator internus": "عضلة سدادية غائرة",
 "obturator externus": "عضلة سدادية خارجية",
 "iliacus": "عضلة حرقفية",
 "gluteus maximus": "عضلة ألوية كبرى",
 "gluteus medius": "عضلة ألوية وسطى",
 "gluteus minimus": "عضلة ألوية صغرى",
 "gemellus superior": "عضلة توأمية علوية",
 "gemellus inferior": "عضلة توأمية سفلية",
 "quadratus femoris": "عضلة مربعة فخذية",
 "sartorius": "عضلة خياطية",
 "semitendinosus": "عضلة نصف وترية",
 "tensor fasciae latae": "عضلة موترة للفافة العريضة",
 "rectus femoris": "العضلة المستقيمة الفخذية",
 "vastus lateralis": "العضلة المتسعة الوحشية",
 "vastus medialis": "العضلة المتسعة الإنسية",
 "vastus intermedius": "العضلة المتسعة المتوسطة",
 "semimembranosus": "عضلة نصف غشائية",
 "pectineus": "عضلة عانية",
 "adductor longus": "عضلة مقربة طويلة",
 "adductor brevis": "عضلة مقربة قصيرة",
 "adductor magnus": "عضلة مقربة كبيرة",
 "muscle of posterior compartment of leg": "ربلة",
 "descending genicular artery": "شريان ركبي نازل",
 "tibialis anterior": "عضلة ظنبوبية أمامية",
 "extensor hallucis longus": "عضلة طويلة باسطة لإبهام القدم",
 "extensor digitorum longus": "عضلة طويلة باسطة لأصابع القدم",
 "superior genicular artery": "شرايين ركبية علوية",
 "middle genicular artery": "شريان ركبي أوسط",
 "inferior genicular artery": "شريان ركبي سفلي",
 "fibularis tertius": "عضلة شظوية ثالثة",
 "fibularis longus": "عضلة شظوية طويلة",
 "fibularis brevis": "عضلة شظوية قصيرة",
 "soleus": "عضلة نعلية",
 "plantaris": "عضلة أخمصية",
 "superior medial genicular artery": "شريان ركبي علوي إنسي",
 "superior lateral genicular artery": "شريان ركبي وحشي علوي",
 "popliteus": "عضلة مأبضية",
 "flexor hallucis longus": "عضلة مثنية طويلة لإبهام القدم",
 "splenius capitis": "عضلة طاحلة رأسية",
 "axillary artery": "شريان إبطي",
 "lateral thoracic artery": "شريان صدري وحشي",
 "subscapular artery": "شريان تحت الكتف",
 "anterior circumflex humeral artery": "شريان منعطف عضدي أمامي",
 "splenius cervicis": "عضلة طاحلة رقبية",
 "posterior circumflex humeral artery": "شريان منعطف عضدي خلفي",
 "brachial artery": "شريان عضدي",
 "deep brachial artery": "شريان عضدي عميق",
 "superior ulnar collateral artery": "شريان زندي جانبي علوي",
 "inferior ulnar collateral artery": "شريان زندي جانبي سفلي",
 "radial artery": "شريان كعبري",
 "radial recurrent artery": "شريان راجع كعبري",
 "dorsal carpal branch of radial artery": "الفرع الرسغي الظهراني للشريان الكعبري",
 "arteria princeps pollicis": "شريان الإبهام الرئيسي",
 "arteria radialis indicis": "شريان كعبري سبابي",
 "ulnar artery": "شريان زندي",
 "anterior ulnar recurrent artery": "شريان زندي أمامي راجع",
 "posterior ulnar recurrent artery": "شريان راجع زندي خلفي",
 "common interosseous artery": "الشريان بين العظام الأصلي",
 "anterior interosseous artery": "الشريان بين العظام الأمامي",
 "dorsal carpal branch of ulnar artery": "الفرع الرسغي الظهراني للشريان الزندي",
 "semispinalis": "العضلات الشوكية النصفية",
 "superficial palmar arterial arch": "قوس راحي سطحي",
 "deep palmar arterial arch": "قوس راحية عميقة",
 "basilic vein": "وريد بازلي",
 "deep palmar venous arch": "قوس وريدي راحي عميق",
 "superficial palmar venous arch": "قوس وريدي راحي سطحي",
 "brachial vein": "وريد عضدي",
 "median cubital vein": "وريد مرفقي ناصف",
 "median antebrachial vein": "وريد ناصف أمام العضد",
 "deltoid branch of thoraco-acromial artery": "الفرع الدالي للشريان الصدري الأخرمي",
 "rotator muscle": "عضلات مديرة",
 "medial collateral artery": "شريان جانبي إنسي",
 "radial collateral artery": "شريان كعبري جانبي",
 "circumflex scapular artery": "شريان لوحي منعطف",
 "radius": "كعبرة",
 "ulna": "زند",
 "scaphoid": "عظم قاربي",
 "lunate": "عظم هلالي",
 "triquetral": "عظم مثلثي",
 "pisiform": "عظم حمصي",
 "trapezium": "عظم مربعي",
 "trapezoid": "عظم شبه منحرف",
 "capitate": "العظم الكبير",
 "hamate": "عظم كلابي",
 "carpal bone": "رسغ اليد",
 "first metacarpal bone": "العظم السنعي الأول",
 "second metacarpal bone": "العظم السنعي الثاني",
 "third metacarpal bone": "العظم السنعي الثالث",
 "fourth metacarpal bone": "العظم السنعي الرابع",
 "fifth metacarpal bone": "العظم السنعي الخامس",
 "tibia": "عظم الظنبوب",
 "fibula": "عظم الشظية",
 "patella": "الرضفة",
 "tarsal bone": "رصغ",
 "phalanx of toe": "سلاميات القدم",
 "calcaneus": "عظم العقب",
 "navicular bone of foot": "عظم زورقي",
 "cuneiform bone": "عظام إسفينية",
 "medial cuneiform bone": "العظم الإسفيني الإنسي",
 "intermediate cuneiform bone": "العظم الإسفيني المتوسط",
 "lateral cuneiform bone": "عظم إسفيني وحشي",
 "cuboid bone": "عظم نردي",
 "prevertebral muscle": "العضلات أمام الفقرات",
 "levator scapulae": "عضلة رافعة للكتف",
 "rectus capitis posterior major": "عضلة مستقيمة رأسية خلفية كبيرة",
 "rectus capitis posterior minor": "عضلة مستقيمة رأسية خلفية صغيرة",
 "obliquus capitis superior": "عضلة مائلة علوية للرأس",
 "obliquus capitis inferior": "عضلة مائلة سفلية للرأس",
 "infraspinatus": "عضلة تحت الشوكة",
 "teres major": "عضلة مدورة كبيرة",
 "teres minor": "عضلة مدورة صغيرة",
 "sesamoid bone": "عظم سمسمي",
 "interosseous membrane of leg": "الغشاء بين عظمي الساق",
 "abductor pollicis brevis": "عضلة قصيرة مبعدة لإبهام اليد",
 "flexor pollicis brevis": "عضلة مثنية قصيرة لإبهام اليد",
 "opponens pollicis": "عضلة مقابلة لإبهام اليد",
 "abductor digiti minimi of hand": "عضلة مبعدة لخنصر اليد",
 "flexor digiti minimi brevis of hand": "عضلة مثنية قصيرة لخنصر اليد",
 "opponens digiti minimi of hand": "عضلة مقابلة للخنصر",
 "abductor hallucis": "عضلة مبعدة لإبهام القدم",
 "flexor digitorum brevis": "عضلة مثنية قصيرة للأصابع",
 "abductor digiti minimi of foot": "عضلة مبعدة لخنصر القدم",
 "flexor accessorius": "عضلة مربعة أخمصية",
 "coracobrachialis": "عضلة غرابية عضدية",
 "brachialis": "عضلة عضدية",
 "anconeus": "عضلة مرفقية",
 "pronator quadratus": "عضلة كابة مربعة",
 "flexor carpi radialis": "عضلة مثنية كعبرية للرسغ",
 "palmaris longus": "عضلة راحية طويلة",
 "flexor digitorum superficialis": "العضلة المثنية السطحية للأصابع",
 "flexor digitorum profundus": "عضلة مثنية عميقة للأصابع",
 "flexor pollicis longus": "عضلة مثنية طويلة لإبهام اليد",
 "brachioradialis": "عضلة عضدية كعبرية",
 "extensor carpi radialis longus": "عضلة كعبرية طويلة باسطة للرسغ",
 "extensor carpi radialis brevis": "عضلة كعبرية قصيرة باسطة للرسغ",
 "extensor digitorum": "عضلة باسطة للأصابع",
 "extensor digiti minimi": "عضلة باسطة للخنصر",
 "extensor carpi ulnaris": "عضلة زندية باسطة للرسغ",
 "supinator": "عضلة باسطة",
 "abductor pollicis longus": "عضلة طويلة مبعدة لإبهام اليد",
 "extensor pollicis brevis": "عضلة قصيرة مادة لإبهام اليد",
 "extensor pollicis longus": "عضلة طويلة مادة لإبهام اليد",
 "extensor indicis": "عضلة مخصوصة باسطة للسبابة",
 "gracilis": "عضلة رقيقة",
 "inferior lateral genicular artery": "شريان ركبي وحشي سفلي",
 "inferior medial genicular artery": "شريان ركبي سفلي إنسي",
 "anterior tibial artery": "شريان قصبة الساق الأمامي",
 "posterior tibial artery": "شريان قصبة الساق الخلفي",
 "anterior tibial recurrent artery": "شريان ظنبوبي راجع أمامي",
 "dorsalis pedis artery": "شريان ظهري للقدم",
 "medial plantar artery": "شريان أخمصي إنسي",
 "lateral plantar artery": "شريان أخمصي وحشي",
 "plantar arch": "القوس الأخمصية",
 "long plantar ligament": "الرباط الأخمصي الطويل",
 "superficial epigastric vein": "وريد شرسوفي سطحي",
 "popliteal vein": "وريد مأبضي",
 "anterior tibial vein": "وريد ظنبوبي أمامي",
 "posterior tibial vein": "وريد ظنبوبي خلفي",
 "small saphenous vein": "وريد صافن صغير",
 "dorsal venous arch of foot": "القوس الوريدية لظهر القدم",
 "plantar venous arch of foot": "القوس الوريدية الأخمصية",
 "arcuate artery": "شريان القدم القوسي",
 "lateral tarsal artery": "الشريان الرصغي الوحشي",
 "anatomical lobe": "فص",
 "parenchyma": "برنشيمة",
 "platysma": "عضلة جلدية للعنق",
 "digastric": "عضلة ذات بطنين",
 "longus capitis": "العضلة الطويلة الرأسية",
 "mylohyoid": "عضلة ضرسية لامية",
 "geniohyoid": "عضلة ذقنية لامية",
 "posterior crico-arytenoid": "عضلة حلقية طرجهالية خلفية",
 "lateral crico-arytenoid": "عضلة حلقية طرجهالية وحشية",
 "transverse arytenoid": "عضلة طرجهالية",
 "oblique arytenoid": "عضلة طرجهالية مائلة",
 "thyro-arytenoid": "عضلة درقية طرجهالية",
 "vocalis": "العضلة الصوتية",
 "aryepiglotticus": "عضلة طرجهالية لسان مزمارية",
 "superior pharyngeal constrictor": "عضلة مضيقة بلعومية علوية",
 "inferior pharyngeal constrictor": "عضلة مضيقة بلعومية سفلية",
 "stylopharyngeus": "العضلة الإبرية البلعومية",
 "salpingopharyngeus": "عضلة نفيرية بلعومية",
 "muscle of tongue": "عضلات اللسان",
 "genioglossus": "عضلة ذقنية لسانية",
 "hyoglossus": "عضلة لامية لسانية",
 "levator veli palatini": "رافعة الشراع الحنكي",
 "tensor veli palatini": "العضلة الموترة للحفاف",
 "uvular muscle": "عضلة اللهاة",
 "muscle of face": "عضلة وجهية",
 "extra-ocular muscle": "عضلات العين",
 "superior rectus": "عضلة مستقيمة علوية",
 "inferior rectus": "عضلة مستقيمة سفلية",
 "medial rectus": "عضلة مستقيمة وسطية",
 "lateral rectus": "عضلة مستقيمة وحشية",
 "superior oblique": "عضلة مائلة علوية",
 "inferior oblique": "عضلة مائلة سفلية",
 "levator palpebrae superioris": "عضلة رافعة الجفن العلوية",
 "trochlea of superior oblique": "بكرة العضلة المائلة العلوية",
 "common tendinous ring": "الحلقة الوترية المشتركة",
 "ophthalmic artery": "شريان عيني",
 "coronary artery": "شرايين تاجية",
 "right inferior pulmonary vein": "الوريد الرئوي السفلي الأيمن",
 "left inferior pulmonary vein": "الوريد الرئوي السفلي الأيسر",
 "right superior pulmonary vein": "الوريد الرئوي العلوي الأيمن",
 "left superior pulmonary vein": "الوريد الرئوي العلوي الأيسر",
 "anterior cerebral artery": "شريان مخي أمامي",
 "posterior communicating artery": "شريان مخي موصل خلفي",
 "anterior choroidal artery": "شريان المشيمية الأمامي",
 "anterior communicating artery": "شريان موصل أمامي",
 "posterior inferior cerebellar artery": "شريان مخيخي سفلي خلفي",
 "anterior spinal artery": "شريان نخاعي أمامي",
 "basilar artery": "شريان قاعدي",
 "anterior inferior cerebellar artery": "شريان مخيخي سفلي أمامي",
 "superior cerebellar artery": "شريان مخيخي علوي",
 "thalamogeniculate artery": "شريان مهادي ركبي",
 "anatomical boundary entity": "حد تشريحي",
 "artery": "شريان",
 "vein": "وريد",
 "hepatic portal vein": "الوريد البابي الكبدي",
 "celiac artery": "شريان بطني",
 "optic nerve": "العصب البصري",
 "trochlear nerve": "عصب بكري",
 "right pulmonary artery": "الشريان الرئوي الأيمن",
 "left pulmonary artery": "الشريان الرئوي الأيسر",
 "deep femoral vein": "وريد فخذي عميق",
 "iliotibial tract": "سبيل حرقفي ظنبوبي",
 "calcaneal tendon": "وتر أخيل",
 "flexor digitorum longus": "عضلة مثنية طويلة للأصابع",
 "tibialis posterior": "عضلة ظنبوبية خلفية",
 "ophthalmic nerve": "عصب عيني",
 "lacrimal nerve": "عصب دمعي",
 "frontal nerve": "عصب جبهي",
 "supratrochlear nerve": "العصب فوق البكرة",
 "supra-orbital nerve": "عصب فوق الحجاج",
 "nasociliary nerve": "عصب أنفي هدبي",
 "communicating branch of nasociliary nerve with ciliary ganglion": "الجذور الحسية للعقدة الهدبية",
 "anterior ethmoidal nerve": "عصب غربالي أمامي",
 "long ciliary nerve": "أعصاب هدبية طويلة",
 "infratrochlear nerve": "العصب تحت البكرة",
 "posterior ethmoidal nerve": "عصب غربالي خلفي",
 "frontal bone": "عظم جبهي",
 "occipital bone": "عظم قذالي",
 "sphenoid bone": "عظم وتدي",
 "temporal bone": "عظم صدغي",
 "ethmoid": "عظم غربالي",
 "lacrimal bone": "عظم دمعي",
 "nasal bone": "عظم أنفي",
 "palatine bone": "عظم حنكي",
 "zygomatic bone": "عظم وجني",
 "mandible": "الفك السفلي",
 "hyoid bone": "عظم لامي",
 "external ear": "أذن خارجية",
 "hair": "شعر",
 "eyebrow": "حاجب عين",
 "pubic hair": "شعر العانة",
 "tongue": "اللسان",
 "inferior nasal concha": "محارة أنفية سفلية",
 "interosseous membrane": "الغشاء بين العظمين",
 "submandibular gland": "الغدة تحت الفك السفلي",
 "thyroid cartilage": "الغضروف الدرقي",
 "laryngeal cartilage": "غضاريف حنجرية",
 "arytenoid cartilage": "الغضروف الطرجهالي",
 "corniculate cartilage": "غضروف قريني",
 "cuneiform cartilage": "غضروف إسفيني",
 "epiglottis": "لسان المزمار",
 "thyrohyoid membrane": "غشاء درقي لامي",
 "median thyrohyoid ligament": "رباط درقي لامي ناصف",
 "lateral thyrohyoid ligament": "رباط درقي لامي جانبي",
 "hyo-epiglottic ligament": "رباط لامي اللسان-مزماري",
 "thyro-epiglottic ligament": "رباط درقي للسان المزماري",
 "cricothyroid ligament": "رباط حلقي درقي",
 "vocal ligament": "الرباط الصوتي",
 "conus elasticus": "المخروط المرن",
 "pterygomandibular raphe": "رفاء جناحي فكي",
 "canine tooth": "ناب",
 "premolar tooth": "ضاحكة",
 "molar tooth": "ضرس",
 "anatomical set": "مجموعة تشريحية",
 "nonparenchymatous organ": "عضو غير متني",
 "upper secondary premolar tooth": "ضواحك علوية",
 "upper first secondary premolar tooth": "ضاحكة أولى علوية",
 "upper second secondary premolar tooth": "ضاحكة ثانية علوية",
 "lower first secondary premolar tooth": "ضاحكة أولى سفلية",
 "lower second secondary premolar tooth": "ضاحكة ثانية سفلية",
 "chamber of eyeball": "غرفة المقلة",
 "anterior chamber of eyeball": "غرفة العين الأمامية",
 "fibrous layer of eyeball": "غلالة ليفية في مقلة العين",
 "iris": "القزحية",
 "cornea": "القرنية",
 "lens": "العدسة",
 "lacrimal canaliculus": "قنية دمعية",
 "sclera": "الصلبة",
 "choroid": "مشيمية",
 "corona ciliaris": "جزء متثني",
 "region of retina": "منطقة في الشبكية",
 "vitreous body": "جسم زجاجي",
 "suspensory ligament of lens": "نطيفة هدبية",
 "tarsal plate of eyelid": "ترص",
 "lacrimal gland": "غدة دمعية",
 "lacrimal lake": "البحيرة الدمعية",
 "nasal cartilage": "غضاريف أنفية",
 "septal nasal cartilage": "غضروف حاجز الأنف",
 "major alar cartilage": "غضروف جناحي كبير",
 "lateral nasal cartilage": "غضروف أنفي وحشي",
 "gingiva": "اللثة",
 "major salivary gland": "الغدة اللعابية الكبرى",
 "sublingual gland": "الغدة تحت اللسان",
 "lip": "شفة",
 "neural tree organ": "عضو في الشجرة العصبية",
 "caudate nucleus": "نواة ذنبية",
 "putamen": "البطامة",
 "globus pallidus": "كرة شاحبة",
 "amygdala": "لوزة دماغية",
 "superior frontal gyrus": "تلفيف جبهي علوي",
 "middle frontal gyrus": "التلفيف الجبهي المتوسط",
 "inferior frontal gyrus": "تلفيف جبهي سفلي",
 "precentral gyrus": "تلفيف أمام المركزي",
 "postcentral gyrus": "تلفيف خلف مركزي",
 "supramarginal gyrus": "تلفيف فوق الهامشي",
 "angular gyrus": "تلفيف زاوي",
 "superior parietal lobule": "فصيص جداري علوي",
 "middle temporal gyrus": "التلفيف الصدغي المتوسط",
 "inferior temporal gyrus": "تلفيف صدغي سفلي",
 "fusiform gyrus": "تلفيف مغزلي",
 "parahippocampal gyrus": "تلفيف مجاور للحصين",
 "choroid plexus of cerebral hemisphere": "ضفيرة مشيموية",
 "internal capsule": "محفظة غائرة",
 "anterior commissure": "صوار أمامي",
 "fornix of forebrain": "قبو الدماغ",
 "commissure of fornix of forebrain": "صوار الحصين",
 "stria terminalis": "سطر انتهائي",
 "lamina terminalis": "الصفيحة الانتهائية",
 "midbrain": "دماغ متوسط",
 "medulla oblongata": "نخاع مستطيل",
 "thalamus": "المهاد",
 "hypothalamus": "الوطاء",
 "habenula": "عنان",
 "pineal body": "غدة صنوبرية",
 "optic chiasm": "التصالب البصري",
 "optic tract": "سبيل بصري",
 "posterior commissure": "صوار خلفي",
 "stria medullaris of thalamus": "سطر نخاعي مهادي",
 "lateral geniculate body": "نواة ركبية وحشية",
 "medial geniculate body": "نواة ركبية إنسية",
 "tuber cinereum": "حدبة رمادية",
 "peduncle of midbrain": "سويقة مخية",
 "superior colliculus": "أكيمة علوية",
 "inferior colliculus": "أكيمة سفلية",
 "cingulate gyrus": "قشرة حزامية",
 "commissure of diencephalon": "صوار الدماغ البيني",
 "scalene muscle": "عضلات أخمعية",
 "heterogeneous cluster": "كتلة تشريحية غير متجانسة",
 "nerve": "عصب",
 "thoracodorsal artery": "شريان صدري ظهراني",
 "pulmonary artery": "جذع رئوي",
 "pulmonary vein": "وريد رئوي",
 "gray matter of neuraxis": "المادة الرمادية",
 "occipital lobe": "فص قذالي",
 "insula": "فص جزيري",
 "organ": "عضو",
 "anatomical cavity": "تجويف تشريحي",
 "pons": "جسر",
 "cerebellum": "مخيخ",
 "dorsal venous network of hand": "شبكة وريدية ظهرانية لليد",
 "inferior phrenic vein": "وريد حجابي سفلي",
 "bronchial artery": "شريان شعبي",
 "inferior suprarenal artery": "شريان كظري سفلي",
 "deep plantar artery": "شريان أخمصي غائر",
 "femoral artery": "شريان فخذي",
 "superior pancreaticoduodenal artery": "شريان بنكرياسي إثنا عشري علوي",
 "anterior inferior pancreaticoduodenal artery": "شريان بنكرياسي اثنا عشري سفلي أمامي",
 "posterior inferior pancreaticoduodenal artery": "شريان بنكرياسي اثنا عشري سفلي خلفي",
 "segmental renal artery": "شرايين قطاعية في الكلى",
 "superior segmental renal artery": "شرايين الكلى القطاعية العلوية",
 "inferior segmental renal artery": "شرايين الكلى القطاعية السفلية",
 "posterior segmental renal artery": "شرايين الكلى القطاعية الخلفية",
 "set of facial hairs": "مجموعة من شعر الوجه",
 "set of dorsal metacarpal arteries": "شرايين ظهارية ظهرانية",
 "set of dorsal digital arteries": "شرايين أصبعية ظهرانية قدمية",
 "set of common plantar digital arteries": "شرايين أخمصية أصلية لأصابع القدم",
 "set of anterior intercostal veins": "الأوردة الوربية الأمامية",
 "set of dorsal digital veins": "أوردة ظهرانية لأصابع القدم",
 "set of plantar digital veins": "أوردة أخمصية لأصابع القدم",
 "skin appendage": "ملحقات الجلد",
 "lateral thoracic vein": "وريد صدري وحشي",
 "set of oesophageal branches of thoracic aorta": "الفروع المريئية للجزء الصدري للأبهر",
 "set of plantar digital arteries proper": "شرايين أخمصية مخصوصة لأصابع القدم",
 "stylohyoid ligament": "الرباط الإبري اللامي",
 "mammillary body": "جسم حلمي",
 "interventricular foramen": "ثقبة بين البطينات",
 "recurrent interosseous artery": "شريان بين العظام راجع",
 "popliteal artery": "شريان باطن الركبة",
 "median sacral vein": "وريد عجزي ناصف",
 "iliocostalis": "عضلة حرقفية ضلعية",
 "longissimus": "عضلة طولى",
 "spinalis": "عضلة ناصبة شوكية",
 "splenius": "عضلة طاحلة",
 "lateral ventricle": "بطين جانبي",
 "third ventricle": "بطين ثالث",
 "cerebral aqueduct": "مسال دماغي",
 "fourth ventricle": "بطين رابع",
 "central canal of spinal cord": "قناة مركزية",
 "dorsal scapular artery": "الشريان الكتفي الظهراني",
 "organ chamber": "غرفة العضو",
 "nucleus of neuraxis": "نواة",
 "peduncle of neuraxis": "سويقة من المحاور",
 "gyrus of neuraxis": "تلفيف",
 "white matter of neuraxis": "المادة البيضاء",
 "tentorium cerebelli": "خيمة المخيخ",
 "circumventricular organ of neuraxis": "أعضاء محيطة بالبطينات",
 "segment of venous tree organ": "جزء من التفرعات الوريدية",
 "corpus callosum": "الجسم الثفني",
 "aorta": "الأبهر",
 "anterior interventricular branch of left coronary artery": "الفرع الأمامي بين البطينين للشريان التاجي الأيسر",
 "heart": "قلب",
 "right atrium": "أذين أيمن",
 "left atrium": "أذين أيسر",
 "right ventricle": "البطين الأيمن",
 "left ventricle": "البطين الأيسر",
 "alimentary system": "جهاز هضمي",
 "head": "رأس الإنسان",
 "neck": "رقبة",
 "nervous system": "جهاز عصبي",
 "respiratory system": "جهاز تنفسي",
 "urinary system": "جهاز بولي",
 "genital system": "جهاز تناسلي بشري",
 "cardiovascular system": "جهاز الدوران",
 "right side of heart": "قلب أيمن",
 "left side of heart": "قلب أيسر",
 "trunk": "جذع",
 "lower limb": "ساق الإنسان",
 "liver": "كبد",
 "small intestine": "الأمعاء الدقيقة",
 "large intestine": "أمعاء غليظة",
 "jejunum": "الصائم",
 "ileum": "اللفائفي",
 "outflow part of right ventricle": "المخروط الشرياني",
 "tricuspid valve": "الصمام ثلاثي الشرف",
 "mitral valve": "الصمام التاجي",
 "aortic valve": "الصمام الأبهري",
 "pulmonary valve": "الصمام الرئوي",
 "right lung": "الرئة اليمنى",
 "middle lobe of lung": "الفص الأوسط للرئة اليمنى",
 "right main bronchus": "قصبة رئيسية يمنى",
 "rib cage": "قفص صدري",
 "musculoskeletal system": "جهاز عضلي هيكلي",
 "sternum": "عظم القص",
 "spinal cord": "نخاع شوكي",
 "outflow part of left ventricle": "دهليز الأبهر",
 "fibrous skeleton of heart": "هيكل القلب",
 "thorax": "صدر",
 "abdomen": "بطن",
 "perineum": "عجان",
 "peritoneum": "صفاق",
 "thymus": "غدة زعترية",
 "endocrine system": "جهاز الغدد الصماء",
 "mediastinum": "منصف",
 "thoracic wall": "جدار الصدر",
 "wall of abdomen proper": "جدار البطن",
 "right lobe of liver": "الفص الأيمن للكبد",
 "left lobe of liver": "الفص الأيسر للكبد",
 "cecum": "أعور",
 "visceral peritoneum": "الصفاق الحشوي",
 "gastroduodenal artery": "شريان معدي إثنا عشري",
 "inferior branch of ileocolic artery": "الفرع السفلي من الشريان اللفائفي القولوني",
 "bony pelvis": "عظم الورك",
 "mons pubis": "جبل العانة",
 "anal part of perineum": "مثلث شرجي",
 "human body": "جسم الإنسان",
 "skeletal system": "هيكل عظمي بشري",
 "face": "وجه",
 "lower respiratory tract": "سبيل تنفسي سفلي",
 "frontal part of head": "هامة",
 "nose": "أنف بشري",
 "skull": "جمجمة الإنسان",
 "upper gastrointestinal tract": "السبيل المعدي المعوي العلوي",
 "mouth": "الفم",
 "occipital part of head": "مؤخر الرأس",
 "right coronary artery": "شريان تاجي أيمن",
 "left coronary artery": "شريان تاجي أيسر",
 "cerebral arterial circle": "دائرة شريانية دماغية",
 "brain": "دماغ",
 "basicranium": "قاعدة الجمجمة",
 "neurocranium": "قحف عصبي",
 "nasal septum": "حاجز الأنف",
 "right eye": "عين الإنسان اليمنى",
 "left eye": "عين الإنسان اليسرى",
 "soft palate": "الحنك الرخو",
 "uvula": "لهاة",
 "neuraxis": "جهاز عصبي مركزي",
 "external nose": "أنف ظاهر",
 "back of abdomen": "منطقة قطنية",
 "forebrain": "دماغ أمامي",
 "telencephalon": "مخ",
 "diencephalon": "دماغ بيني",
 "metencephalon": "دماغ تالي",
 "epithalamus": "فوق المهاد",
 "hindbrain": "دماغ خلفي",
 "integumentary system": "الجهاز الغلافي",
 "brainstem": "جذع الدماغ",
 "midbrain tectum": "سقف الدماغ المتوسط",
 "ventricular system of brain": "جهاز بطيني",
 "abdominal segment of trunk": "الجزء البطني من الجذع",
 "respiratory tract": "سبيل تنفسي",
 "lungs": "الرئتان",
 "lung": "رئة",
 "colon": "القولون",
 "caecum": "الأعور",
 "vermiform appendix": "الزائدة الدودية",
 "sigmoid colon": "القولون السيني",
 "biliary tree": "الشجرة الصفراوية",
 "common bile duct": "القناة الصفراوية المشتركة",
 "couinaud liver segment": "قطعة كبدية",
 "omentum": "الثرب",
 "tooth row": "صف الأسنان",
 "hard palate": "الحنك الصلب",
 "parotid gland": "الغدة النكفية",
 "dorsal tongue": "ظهر اللسان",
 "ventral tongue": "بطن اللسان",
 "mouth floor": "أرضية الفم",
 "buccal mucosa": "المخاطية الشدقية",
 "frenulum of lip": "لجام الشفة",
 "circumvallate papillae": "الحليمات الكأسية",
 "fungiform papillae": "الحليمات الكمئية",
 "renal pelvis": "حويضة الكلية",
 "renal pyramid": "الهرم الكلوي",
 "renal papilla": "الحليمة الكلوية",
 "renal medulla": "لب الكلية",
 "renal column": "العمود الكلوي",
 "outer cortex of kidney": "قشرة الكلية",
 "major calyx": "الكأس الكلوي الكبير",
 "minor calyx": "الكأس الكلوي الصغير",
 "trigone of urinary bladder": "مثلث المثانة",
 "larynx": "الحنجرة",
 "bronchi": "القصبات",
 "tracheobronchial tree": "الشجرة الرغامية القصبية",
 "carina": "الجؤجؤ",
 "epiglotic cartilage": "غضروف لسان المزمار",
 "tracheal cartilage": "الغضروف الرغامي",
 "bronchopulmonary segment": "قطعة قصبية رئوية",
 "cardiac chamber": "حجرة قلبية",
 "left cardiac atrium": "الأذين الأيسر",
 "right cardiac atrium": "الأذين الأيمن",
 "interventricular septum": "الحاجز بين البطينين",
 "papillary muscle of heart": "العضلة الحليمية",
 "aortic arch": "قوس الأبهر",
 "celiac trunk": "الجذع البطني",
 "blood vasculature": "الأوعية الدموية",
 "arteries of heart": "الشرايين التاجية",
 "veins of heart": "أوردة القلب",
 "lymph node": "عقدة لمفية",
 "palatine tonsil": "اللوزة الحنكية",
 "capsule of lymph node": "محفظة العقدة اللمفية",
 "follicles of lymph node": "جريبات العقدة اللمفية",
 "paracortex of lymph node": "جوار قشرة العقدة اللمفية",
 "medulla of lymph node": "لب العقدة اللمفية",
 "afferent lymphatic vessel": "وعاء لمفي وارد",
 "efferent lymph node": "وعاء لمفي صادر",
 "thymus lobe": "فص التوتة",
 "hilum of spleen": "سرة الطحال",
 "uterus": "الرحم",
 "ovary": "المبيض",
 "fallopian tube": "قناة فالوب",
 "uterine tube": "البوق الرحمي",
 "vagina": "المهبل",
 "cervix": "عنق الرحم",
 "mammary gland": "الغدة الثديية",
 "nipple": "الحلمة",
 "areola": "هالة الثدي",
 "mammary lobes": "فصوص الثدي",
 "main lactiferous ducts": "القنوات اللبنية",
 "ligaments of uterus and ovaries": "أربطة الرحم والمبيضين",
 "broad ligament": "الرباط العريض",
 "round ligament of uterus": "الرباط المدور للرحم",
 "uterosacral ligament": "الرباط الرحمي العجزي",
 "cardinal ligament of uterus": "الرباط الأساسي للرحم",
 "suspensory ligament of ovary": "الرباط المعلق للمبيض",
 "ovarian ligament": "رباط المبيض",
 "mesosalpinx": "مساريق البوق",
 "mesovarium": "مساريق المبيض",
 "fimbriae of uterine tube": "أهداب البوق",
 "placenta": "المشيمة",
 "umbilical cord": "الحبل السري",
 "amnion": "السلى",
 "chorionic plate": "الصفيحة المشيمائية",
 "basal plate": "الصفيحة القاعدية",
 "umbilical artery": "الشريان السري",
 "umbilical vein": "الوريد السري",
 "eye": "العين",
 "retina": "الشبكية",
 "pupil": "البؤبؤ",
 "optic choroid": "المشيمية",
 "ciliary body": "الجسم الهدبي",
 "vitreous humor": "الخلط الزجاجي",
 "aqueous humor": "الخلط المائي",
 "macula lutea": "اللطخة الصفراء",
 "fovea": "النقرة المركزية",
 "optic disc": "القرص البصري",
 "ora serrata of retina": "الحافة المسننة للشبكية",
 "trabecular meshwork": "الشبكة التربيقية",
 "bulbar conjunctiva": "الملتحمة المقلية",
 "dura mater": "الأم الجافية",
 "brain hemisphere": "نصف الكرة المخية",
 "hippocampus": "الحصين",
 "amygdaloid complex": "المجمع اللوزي",
 "claustrum": "السياج",
 "fornix": "القبو",
 "substantia nigra": "المادة السوداء",
 "olfactory bulb": "البصلة الشمية",
 "cerebellar vermis": "دودة المخيخ",
 "coccyx": "العصعص",
 "pelvis": "الحوض",
 "ilium": "الحرقفة",
 "ischium": "الإسك",
 "pubis": "العانة",
 "vertebral column": "العمود الفقري",
 "knee joint": "مفصل الركبة",
 "intervertebral joint": "المفصل بين الفقرات",
 "nucleus pulposus": "النواة اللبية",
 "meniscus": "الغضروف الهلالي",
 "anterior cruciate ligament of knee": "الرباط الصليبي الأمامي",
 "posterior cruciate ligament of knee": "الرباط الصليبي الخلفي",
 "articular cartilage of knee": "الغضروف المفصلي للركبة",
 "patellar ligament": "الرباط الرضفي",
 "fibular collateral ligament": "الرباط الجانبي الشظوي",
 "navicular bone": "العظم الزورقي",
 "superior gemellus": "العضلة التوأمية العلوية",
 "inferior gemellus": "العضلة التوأمية السفلية",
 "biceps femoris long": "الرأس الطويل للعضلة ذات الرأسين الفخذية",
 "biceps femoris short": "الرأس القصير للعضلة ذات الرأسين الفخذية",
 "gastrocnemius medial": "الرأس الإنسي للعضلة التوأمية الساقية",
 "gastrocnemius lateral": "الرأس الوحشي للعضلة التوأمية الساقية",
 "peroneus longus": "العضلة الشظوية الطويلة",
 "subcutaneous abdominal adipose tissue": "النسيج الشحمي تحت الجلد في البطن",
 "right internal carotid artery": "شريان سباتي باطن أيمن",
 "right vertebral artery": "شريان فقري أيمن",
 "right internal thoracic artery": "شريان صدري غائر أيمن",
 "right superior epigastric artery": "شريان شرسوفي علوي أيمن",
 "right thyrocervical trunk": "الجذع الدرقي الرقبي الأيمن",
 "right dorsal scapular artery": "الشريان الكتفي الظهراني الأيمن",
 "left internal carotid artery": "شريان سباتي باطن أيسر",
 "left vertebral artery": "شريان فقري أيسر",
 "left internal thoracic artery": "شريان صدري غائر أيسر",
 "left superior epigastric artery": "شريان شرسوفي علوي أيسر",
 "left thyrocervical trunk": "الجذع الدرقي الرقبي الأيسر",
 "left costocervical trunk": "جذع ضلعي رقبي أيسر",
 "left deep cervical artery": "شريان رقبي عميق أيسر",
 "right subcostal artery": "شرايين تحت الضلع الأيمن",
 "left subcostal artery": "شرايين تحت الضلع الأيسر",
 "right brachiocephalic vein": "وريد عضدي رأسي أيمن",
 "right internal jugular vein": "وريد وداجي باطن أيمن",
 "right subclavian vein": "وريد تحت ترقوة أيمن",
 "right internal thoracic vein": "وريد صدري غائر أيمن",
 "left brachiocephalic vein": "وريد عضدي رأسي أيسر",
 "left internal jugular vein": "وريد وداجي باطن أيسر",
 "left subclavian vein": "وريد تحت ترقوة أيسر",
 "right ascending lumbar vein": "وريد قطني صاعد أيمن",
 "right subcostal vein": "وريد تحت الضلع الأيمن",
 "left ascending lumbar vein": "وريد قطني صاعد أيسر",
 "left subcostal vein": "وريد تحت الضلع الأيسر",
 "right costocervical trunk": "جذع ضلعي رقبي أيمن",
 "right kidney": "كلية يمنى",
 "left kidney": "كلية يسرى",
 "right testis": "خصية يمنى",
 "left testis": "خصية يسرى",
 "first rib": "الضلع الأول",
 "first costal cartilage": "الغضروف الضلعي الأول",
 "second rib": "الضلع الثاني",
 "third rib": "الضلع الثالث",
 "second costal cartilage": "الغضروف الضلعي الثاني",
 "third costal cartilage": "الغضروف الضلعي الثالث",
 "fourth rib": "الضلع الرابع",
 "fourth costal cartilage": "الغضروف الضلعي الرابع",
 "fifth rib": "الضلع الخامس",
 "fifth costal cartilage": "الغضروف الضلعي الخامس",
 "sixth costal cartilage": "الغضروف الضلعي السادس",
 "seventh rib": "الضلع السابع",
 "seventh costal cartilage": "الغضروف الضلعي السابع",
 "right first rib": "الضلع الأول الأيمن",
 "right first costal cartilage": "الغضروف الضلعي الأول الأيمن",
 "right second rib": "الضلع الثاني الأيمن",
 "right second costal cartilage": "الغضروف الضلعي الثاني الأيمن",
 "right third rib": "الضلع الثالث الأيمن",
 "right third costal cartilage": "الغضروف الضلعي الثالث الأيمن",
 "right fourth rib": "الضلع الرابع الأيمن",
 "right fourth costal cartilage": "الغضروف الضلعي الرابع الأيمن",
 "left first rib": "الضلع الأول الأيسر",
 "left first costal cartilage": "الغضروف الضلعي الأول الأيسر",
 "left second rib": "الضلع الثاني الأيسر",
 "left second costal cartilage": "الغضروف الضلعي الثاني الأيسر",
 "left third rib": "الضلع الثالث الأيسر",
 "left third costal cartilage": "الغضروف الضلعي الثالث الأيسر",
 "right fifth rib": "الضلع الخامس الأيمن",
 "right fifth costal cartilage": "الغضروف الضلعي الخامس الأيمن",
 "left fifth rib": "الضلع الخامس الأيسر",
 "left fifth costal cartilage": "الغضروف الضلعي الخامس الأيسر",
 "eighth rib": "الضلع الثامن",
 "sixth rib": "الضلع السادس",
 "left fourth rib": "الضلع الرابع الأيسر",
 "left fourth costal cartilage": "الغضروف الضلعي الرابع الأيسر",
 "right sixth rib": "الضلع السادس الأيمن",
 "right sixth costal cartilage": "الغضروف الضلعي السادس الأيمن",
 "left sixth rib": "الضلع السادس الأيسر",
 "left sixth costal cartilage": "الغضروف الضلعي السادس الأيسر",
 "right seventh rib": "الضلع السابع الأيمن",
 "right seventh costal cartilage": "الغضروف الضلعي السابع الأيمن",
 "left seventh rib": "الضلع السابع الأيسر",
 "left seventh costal cartilage": "الغضروف الضلعي السابع الأيسر",
 "right eighth rib": "الضلع الثامن الأيمن",
 "left eighth rib": "الضلع الثامن الأيسر",
 "ninth rib": "الضلع التاسع",
 "right ninth rib": "الضلع التاسع الأيمن",
 "left ninth rib": "الضلع التاسع الأيسر",
 "tenth rib": "الضلع العاشر",
 "right tenth rib": "الضلع العاشر الأيمن",
 "left tenth rib": "الضلع العاشر الأيسر",
 "eleventh rib": "الضلع الحادي عشر",
 "twelfth rib": "الضلع الثاني عشر",
 "right eleventh rib": "الضلع الحادي عشر الأيمن",
 "left eleventh rib": "الضلع الحادي عشر الأيسر",
 "right twelfth rib": "الضلع الثاني عشر الأيمن",
 "left twelfth rib": "الضلع الثاني عشر الأيسر",
 "first thoracic vertebra": "الفقرة الصدرية الأولى",
 "second thoracic vertebra": "الفقرة الصدرية الثانية",
 "third thoracic vertebra": "الفقرة الصدرية الثالثة",
 "fourth thoracic vertebra": "الفقرة الصدرية الرابعة",
 "right transversus thoracis": "العضلة المستعرضة الصدرية اليمنى",
 "left transversus thoracis": "العضلة المستعرضة الصدرية اليسرى",
 "fifth thoracic vertebra": "الفقرة الصدرية الخامسة",
 "sixth thoracic vertebra": "الفقرة الصدرية السادسة",
 "seventh thoracic vertebra": "الفقرة الصدرية السابعة",
 "eighth thoracic vertebra": "الفقرة الصدرية الثامنة",
 "ninth thoracic vertebra": "الفقرة الصدرية التاسعة",
 "tenth thoracic vertebra": "الفقرة الصدرية العاشرة",
 "eleventh thoracic vertebra": "الفقرة الصدرية الحادية عشرة",
 "twelfth thoracic vertebra": "الفقرة الصدرية الثانية عشرة",
 "left dorsal scapular artery": "الشريان الكتفي الظهراني الأيسر",
 "right deep cervical artery": "شريان رقبي عميق أيمن",
 "left inferior thyroid artery": "الشريان الدرقي السفلي الأيسر",
 "left suprascapular artery": "شريان فوق الكتف الأيسر",
 "left transverse cervical artery": "شريان رقبي مستعرض أيسر",
 "left superficial cervical artery": "الفرع الظاهر للشريان الرقبي المستعرض الأيسر",
 "right inferior thyroid artery": "الشريان الدرقي السفلي الأيمن",
 "right suprascapular artery": "شريان فوق الكتف الأيمن",
 "right transverse cervical artery": "شريان رقبي مستعرض أيمن",
 "right superficial cervical artery": "الفرع الظاهر للشريان الرقبي المستعرض الأيمن",
 "third cervical vertebra": "الفقرة العنقية الثالثة",
 "fourth cervical vertebra": "الفقرة العنقية الرابعة",
 "fifth cervical vertebra": "الفقرة العنقية الخامسة",
 "sixth cervical vertebra": "الفقرة العنقية السادسة",
 "seventh cervical vertebra": "الفقرة العنقية السابعة",
 "first lumbar vertebra": "الفقرة القطنية الأولى",
 "second lumbar vertebra": "الفقرة القطنية الثانية",
 "third lumbar vertebra": "الفقرة القطنية الثالثة",
 "fourth lumbar vertebra": "الفقرة القطنية الرابعة",
 "fifth lumbar vertebra": "الفقرة القطنية الخامسة",
 "right clavicle": "ترقوة يمنى",
 "left clavicle": "ترقوة يسرى",
 "right cephalic vein": "وريد رأسي أيمن",
 "left cephalic vein": "وريد رأسي أيسر",
 "right axillary vein": "وريد إبطي أيمن",
 "left axillary vein": "وريد إبطي أيسر",
 "right external oblique": "عضلة مائلة خارجية يمنى",
 "left external oblique": "عضلة مائلة خارجية يسرى",
 "right sternohyoid": "عضلة قصية لامية يمنى",
 "left sternohyoid": "عضلة قصية لامية يسرى",
 "right omohyoid": "عضلة كتفية لامية يمنى",
 "left omohyoid": "عضلة كتفية لامية يسرى",
 "right sternothyroid": "عضلة قصية درقية يمنى",
 "left sternothyroid": "عضلة قصية درقية يسرى",
 "right thyrohyoid": "عضلة درقية لامية يمنى",
 "left thyrohyoid": "عضلة درقية لامية يسرى",
 "right pectoralis minor": "عضلة صدرية صغيرة يمنى",
 "left pectoralis minor": "عضلة صدرية صغيرة يسرى",
 "right rhomboid major": "عضلة معينية كبيرة يمنى",
 "left rhomboid major": "عضلة معينية كبيرة يسرى",
 "right rhomboid minor": "عضلة معينية صغيرة يمنى",
 "left rhomboid minor": "عضلة معينية صغيرة يسرى",
 "right scalenus medius": "العضلة الأخمعية المتوسطة اليمنى",
 "left scalenus medius": "العضلة الأخمعية المتوسطة اليسرى",
 "right scalenus anterior": "الأخمعية الأمامية اليمنى",
 "left scalenus anterior": "الأخمعية الأمامية اليسرى",
 "right scapula": "لوح الكتف الأيمن",
 "left scapula": "لوح الكتف الأيسر",
 "right serratus anterior": "عضلة منشارية أمامية يمنى",
 "left serratus anterior": "عضلة منشارية أمامية يسرى",
 "right sternocleidomastoid": "عضلة قصية ترقوية حلمية يمنى",
 "left sternocleidomastoid": "عضلة قصية ترقوية حلمية يسرى",
 "left subclavius": "عضلة تحت ترقوية يسرى",
 "right subclavius": "عضلة تحت ترقوية يمنى",
 "right subscapularis": "عضلة تحت الكتف اليمنى",
 "left subscapularis": "عضلة تحت الكتف اليسرى",
 "right renal vein": "وريد كلوي أيمن",
 "left renal vein": "وريد كلوي أيسر",
 "right hepatic vein": "وريد كبدي أيمن",
 "left hepatic vein": "وريد كبدي أيسر",
 "right testicular vein": "وريد خصوي أيمن",
 "right suprarenal vein": "وريد كظري أيمن",
 "left testicular vein": "وريد خصوي أيسر",
 "left suprarenal vein": "وريد كظري أيسر",
 "right inferior phrenic artery": "شريان حجابي سفلي أيمن",
 "left inferior phrenic artery": "شريان حجابي سفلي أيسر",
 "right renal artery": "شريان كلوي أيمن",
 "left renal artery": "شريان كلوي أيسر",
 "right middle suprarenal artery": "شرايين وسطى كظرية أيمن",
 "left middle suprarenal artery": "شرايين وسطى كظرية أيسر",
 "right testicular artery": "شريان خصوي أيمن",
 "left testicular artery": "شريان خصوي أيسر",
 "right common iliac artery": "شريان حرقفي أصلي أيمن",
 "left common iliac artery": "شريان حرقفي أصلي أيسر",
 "right ureter": "الحالب الأيمن",
 "left ureter": "الحالب الأيسر",
 "right adrenal gland": "غدة كظرية يمنى",
 "left adrenal gland": "غدة كظرية يسرى",
 "right hip bone": "عظم الورك الأيمن",
 "left hip bone": "عظم الورك الأيسر",
 "right epididymis": "بربخ أيمن",
 "left epididymis": "بربخ أيسر",
 "right external iliac artery": "شريان حرقفي ظاهر أيمن",
 "left external iliac artery": "شريان حرقفي ظاهر أيسر",
 "right internal iliac artery": "شريان حرقفي غائر أيمن",
 "left internal iliac artery": "شريان حرقفي غائر أيسر",
 "right external iliac vein": "وريد حرقفي ظاهر أيمن",
 "left external iliac vein": "وريد حرقفي ظاهر أيسر",
 "right internal iliac vein": "وريد حرقفي غائر أيمن",
 "left internal iliac vein": "وريد حرقفي غائر أيسر",
 "right iliolumbar vein": "وريد حرقفي قطني أيمن",
 "left iliolumbar vein": "وريد حرقفي قطني أيسر",
 "right internal pudendal vein": "وريد فرجي غائر أيمن",
 "left internal pudendal vein": "وريد فرجي غائر أيسر",
 "right deferent duct": "أسهر أيمن",
 "left deferent duct": "أسهر أيسر",
 "right seminal vesicle": "حويصلة منوية يمنى",
 "left seminal vesicle": "حويصلة منوية يسرى",
 "right inferior epigastric artery": "شريان شرسوفي سفلي أيمن",
 "left inferior epigastric artery": "شريان شرسوفي سفلي أيسر",
 "right superficial epigastric artery": "شريان شرسوفي سطحي أيمن",
 "left superficial epigastric artery": "شريان شرسوفي سطحي أيسر",
 "right lateral circumflex femoral artery": "شريان فخذي منعطف وحشي أيمن",
 "left lateral circumflex femoral artery": "شريان فخذي منعطف وحشي أيسر",
 "right dorsal artery of penis": "شريان قضيبي ظهراني أيمن",
 "left dorsal artery of penis": "شريان قضيبي ظهراني أيسر",
 "right inferior epigastric vein": "وريد شرسوفي سفلي أيمن",
 "left inferior epigastric vein": "وريد شرسوفي سفلي أيسر",
 "right femoral vein": "وريد فخذي أيمن",
 "left femoral vein": "وريد فخذي أيسر",
 "right great saphenous vein": "وريد صافن كبير أيمن",
 "left great saphenous vein": "وريد صافن كبير أيسر",
 "right common iliac vein": "وريد حرقفي أصلي أيمن",
 "left common iliac vein": "وريد حرقفي أصلي أيسر",
 "right iliacus": "عضلة حرقفية يمنى",
 "left iliacus": "عضلة حرقفية يسرى",
 "right obturator internus": "عضلة سدادية غائرة يمنى",
 "left obturator internus": "عضلة سدادية غائرة يسرى",
 "right obturator externus": "عضلة سدادية خارجية يمنى",
 "left obturator externus": "عضلة سدادية خارجية يسرى",
 "right gluteus maximus": "عضلة ألوية كبرى يمنى",
 "left gluteus maximus": "عضلة ألوية كبرى يسرى",
 "right gluteus medius": "عضلة ألوية وسطى يمنى",
 "left gluteus medius": "عضلة ألوية وسطى يسرى",
 "right gluteus minimus": "عضلة ألوية صغرى يمنى",
 "left gluteus minimus": "عضلة ألوية صغرى يسرى",
 "right gemellus superior": "عضلة توأمية علوية يمنى",
 "left gemellus superior": "عضلة توأمية علوية يسرى",
 "right gemellus inferior": "عضلة توأمية سفلية يمنى",
 "left gemellus inferior": "عضلة توأمية سفلية يسرى",
 "right quadratus femoris": "عضلة مربعة فخذية يمنى",
 "left quadratus femoris": "عضلة مربعة فخذية يسرى",
 "right piriformis": "عضلة كمثرية يمنى",
 "left piriformis": "عضلة كمثرية يسرى",
 "right psoas major": "عضلة قطنية كبيرة يمنى",
 "left psoas major": "عضلة قطنية كبيرة يسرى",
 "right sartorius": "عضلة خياطية يمنى",
 "left sartorius": "عضلة خياطية يسرى",
 "right semitendinosus": "عضلة نصف وترية يمنى",
 "left semitendinosus": "عضلة نصف وترية يسرى",
 "right tensor fasciae latae": "عضلة موترة للفافة العريضة اليمنى",
 "left tensor fasciae latae": "عضلة موترة للفافة العريضة اليسرى",
 "right semimembranosus": "عضلة نصف غشائية يمنى",
 "left semimembranosus": "عضلة نصف غشائية يسرى",
 "right pectineus": "عضلة عانية يمنى",
 "left pectineus": "عضلة عانية يسرى",
 "right adductor brevis": "عضلة مقربة قصيرة يمنى",
 "left adductor brevis": "عضلة مقربة قصيرة يسرى",
 "right adductor longus": "عضلة مقربة طويلة يمنى",
 "left adductor longus": "عضلة مقربة طويلة يسرى",
 "right adductor magnus": "عضلة مقربة كبيرة يمنى",
 "left adductor magnus": "عضلة مقربة كبيرة يسرى",
 "right descending genicular artery": "شريان ركبي نازل أيمن",
 "left descending genicular artery": "شريان ركبي نازل أيسر",
 "right tibialis anterior": "عضلة ظنبوبية أمامية يمنى",
 "left tibialis anterior": "عضلة ظنبوبية أمامية يسرى",
 "right extensor hallucis longus": "عضلة طويلة باسطة لإبهام القدم اليمنى",
 "left extensor hallucis longus": "عضلة طويلة باسطة لإبهام القدم اليسرى",
 "right extensor digitorum longus": "عضلة طويلة باسطة لأصابع القدم اليمنى",
 "left extensor digitorum longus": "عضلة طويلة باسطة لأصابع القدم اليسرى",
 "right fibularis tertius": "عضلة شظوية ثالثة يمنى",
 "left fibularis tertius": "عضلة شظوية ثالثة يسرى",
 "right fibularis longus": "عضلة شظوية طويلة يمنى",
 "left fibularis longus": "عضلة شظوية طويلة يسرى",
 "right fibularis brevis": "عضلة شظوية قصيرة يمنى",
 "left fibularis brevis": "عضلة شظوية قصيرة يسرى",
 "right soleus": "عضلة نعلية يمنى",
 "left soleus": "عضلة نعلية يسرى",
 "right plantaris": "عضلة أخمصية يمنى",
 "left plantaris": "عضلة أخمصية يسرى",
 "right middle genicular artery": "شريان ركبي أوسط أيمن",
 "left middle genicular artery": "شريان ركبي أوسط أيسر",
 "right popliteus": "عضلة مأبضية يمنى",
 "left popliteus": "عضلة مأبضية يسرى",
 "right axillary artery": "شريان إبطي أيمن",
 "left axillary artery": "شريان إبطي أيسر",
 "right lateral thoracic artery": "شريان صدري وحشي أيمن",
 "left lateral thoracic artery": "شريان صدري وحشي أيسر",
 "right subscapular artery": "شريان تحت الكتف الأيمن",
 "left subscapular artery": "شريان تحت الكتف الأيسر",
 "right anterior circumflex humeral artery": "شريان منعطف عضدي أمامي أيمن",
 "left anterior circumflex humeral artery": "شريان منعطف عضدي أمامي أيسر",
 "right posterior circumflex humeral artery": "شريان منعطف عضدي خلفي أيمن",
 "left posterior circumflex humeral artery": "شريان منعطف عضدي خلفي أيسر",
 "right brachial artery": "شريان عضدي أيمن",
 "left brachial artery": "شريان عضدي أيسر",
 "right deep brachial artery": "شريان عضدي عميق أيمن",
 "left deep brachial artery": "شريان عضدي عميق أيسر",
 "right superior ulnar collateral artery": "شريان زندي جانبي علوي أيمن",
 "left superior ulnar collateral artery": "شريان زندي جانبي علوي أيسر",
 "right inferior ulnar collateral artery": "شريان زندي جانبي سفلي أيمن",
 "left inferior ulnar collateral artery": "شريان زندي جانبي سفلي أيسر",
 "right splenius cervicis": "عضلة طاحلة رقبية يمنى",
 "left splenius cervicis": "عضلة طاحلة رقبية يسرى",
 "right splenius capitis": "عضلة طاحلة رأسية يمنى",
 "left splenius capitis": "عضلة طاحلة رأسية يسرى",
 "right radial artery": "شريان كعبري أيمن",
 "left radial artery": "شريان كعبري أيسر",
 "right radial recurrent artery": "شريان راجع كعبري أيمن",
 "left radial recurrent artery": "شريان راجع كعبري أيسر",
 "right arteria radialis indicis": "شريان كعبري سبابي أيمن",
 "left arteria radialis indicis": "شريان كعبري سبابي أيسر",
 "right ulnar artery": "شريان زندي أيمن",
 "left ulnar artery": "شريان زندي أيسر",
 "right anterior ulnar recurrent artery": "شريان زندي أمامي راجع أيمن",
 "left anterior ulnar recurrent artery": "شريان زندي أمامي راجع أيسر",
 "right posterior ulnar recurrent artery": "شريان راجع زندي خلفي أيمن",
 "left posterior ulnar recurrent artery": "شريان راجع زندي خلفي أيسر",
 "right common interosseous artery": "الشريان بين العظام الأصلي الأيمن",
 "left common interosseous artery": "الشريان بين العظام الأصلي الأيسر",
 "right anterior interosseous artery": "الشريان بين العظام الأمامي الأيمن",
 "left anterior interosseous artery": "الشريان بين العظام الأمامي الأيسر",
 "right dorsal carpal branch of ulnar artery": "الفرع الرسغي الظهراني للشريان الزندي الأيمن",
 "left dorsal carpal branch of ulnar artery": "الفرع الرسغي الظهراني للشريان الزندي الأيسر",
 "right superficial palmar arterial arch": "قوس راحي سطحي أيمن",
 "left superficial palmar arterial arch": "قوس راحي سطحي أيسر",
 "right arteria princeps pollicis": "شريان الإبهام الرئيسي الأيمن",
 "left arteria princeps pollicis": "شريان الإبهام الرئيسي الأيسر",
 "right basilic vein": "وريد بازلي أيمن",
 "left basilic vein": "وريد بازلي أيسر",
 "right deep palmar venous arch": "قوس وريدي راحي عميق أيمن",
 "left deep palmar venous arch": "قوس وريدي راحي عميق أيسر",
 "right superficial palmar venous arch": "قوس وريدي راحي سطحي أيمن",
 "left superficial palmar venous arch": "قوس وريدي راحي سطحي أيسر",
 "right median cubital vein": "وريد مرفقي ناصف أيمن",
 "left median cubital vein": "وريد مرفقي ناصف أيسر",
 "right median antebrachial vein": "وريد ناصف أمام العضد الأيمن",
 "left median antebrachial vein": "وريد ناصف أمام العضد الأيسر",
 "right humerus": "عظم العضد الأيمن",
 "left humerus": "عظم العضد الأيسر",
 "right circumflex scapular artery": "شريان لوحي منعطف أيمن",
 "left circumflex scapular artery": "شريان لوحي منعطف أيسر",
 "right radius": "كعبرة يمنى",
 "left radius": "كعبرة يسرى",
 "right ulna": "زند أيمن",
 "left ulna": "زند أيسر",
 "right trapezoid": "عظم شبه منحرف أيمن",
 "right scaphoid": "عظم قاربي أيمن",
 "left scaphoid": "عظم قاربي أيسر",
 "right lunate": "عظم هلالي أيمن",
 "left lunate": "عظم هلالي أيسر",
 "right triquetral": "عظم مثلثي أيمن",
 "left triquetral": "عظم مثلثي أيسر",
 "right pisiform": "عظم حمصي أيمن",
 "left pisiform": "عظم حمصي أيسر",
 "right trapezium": "عظم مربعي أيمن",
 "left trapezium": "عظم مربعي أيسر",
 "left trapezoid": "عظم شبه منحرف أيسر",
 "right capitate": "العظم الكبير الأيمن",
 "left capitate": "العظم الكبير الأيسر",
 "right hamate": "عظم كلابي أيمن",
 "left hamate": "عظم كلابي أيسر",
 "right first metacarpal bone": "المشط اليد الأول الأيمن",
 "left first metacarpal bone": "المشط اليد الأول الأيسر",
 "right second metacarpal bone": "المشط اليد الثاني الأيمن",
 "left second metacarpal bone": "المشط اليد الثاني الأيسر",
 "right third metacarpal bone": "المشط اليد الثالث الأيمن",
 "left third metacarpal bone": "المشط اليد الثالث الأيسر",
 "right fourth metacarpal bone": "المشط اليد الرابع الأيمن",
 "left fourth metacarpal bone": "المشط اليد الرابع الأيسر",
 "right fifth metacarpal bone": "المشط اليد الخامس الأيمن",
 "left fifth metacarpal bone": "المشط اليد الخامس الأيسر",
 "right femur": "عظم الفخذ الأيمن",
 "left femur": "عظم الفخذ الأيسر",
 "right tibia": "عظم الظنبوب الأيمن",
 "left tibia": "عظم الظنبوب الأيسر",
 "right fibula": "عظم الشظية الأيمن",
 "left fibula": "عظم الشظية الأيسر",
 "right talus": "عظم الكاحل الأيمن",
 "left talus": "عظم الكاحل الأيسر",
 "right patella": "الرضفة اليمنى",
 "left patella": "الرضفة اليسرى",
 "right calcaneus": "عظم العقب الأيمن",
 "left calcaneus": "عظم العقب الأيسر",
 "right medial cuneiform bone": "العظم الإسفيني الإنسي الأيمن",
 "left medial cuneiform bone": "العظم الإسفيني الإنسي الأيسر",
 "right intermediate cuneiform bone": "العظم الإسفيني المتوسط الأيمن",
 "left intermediate cuneiform bone": "العظم الإسفيني المتوسط الأيسر",
 "right lateral cuneiform bone": "عظم إسفيني وحشي أيمن",
 "left lateral cuneiform bone": "عظم إسفيني وحشي أيسر",
 "right cuboid bone": "عظم نردي أيمن",
 "left cuboid bone": "عظم نردي أيسر",
 "right rectus capitis posterior major": "عضلة مستقيمة رأسية خلفية كبيرة يمنى",
 "left rectus capitis posterior major": "عضلة مستقيمة رأسية خلفية كبيرة يسرى",
 "right rectus capitis posterior minor": "عضلة مستقيمة رأسية خلفية صغيرة يمنى",
 "left rectus capitis posterior minor": "عضلة مستقيمة رأسية خلفية صغيرة يسرى",
 "right obliquus capitis superior": "عضلة مائلة علوية للرأس يمنى",
 "left obliquus capitis superior": "عضلة مائلة علوية للرأس يسرى",
 "right obliquus capitis inferior": "عضلة مائلة سفلية للرأس يمنى",
 "left obliquus capitis inferior": "عضلة مائلة سفلية للرأس يسرى",
 "right levator scapulae": "عضلة رافعة للكتف يمنى",
 "left levator scapulae": "عضلة رافعة للكتف يسرى",
 "right supraspinatus": "عضلة فوق الشوكة اليمنى",
 "left supraspinatus": "عضلة فوق الشوكة اليسرى",
 "right teres major": "عضلة مدورة كبيرة يمنى",
 "left teres major": "عضلة مدورة كبيرة يسرى",
 "right teres minor": "عضلة مدورة صغيرة يمنى",
 "left teres minor": "عضلة مدورة صغيرة يسرى",
 "right abductor pollicis brevis": "عضلة قصيرة مبعدة لإبهام اليد اليمنى",
 "left abductor pollicis brevis": "عضلة قصيرة مبعدة لإبهام اليد اليسرى",
 "right flexor pollicis brevis": "عضلة مثنية قصيرة لإبهام اليد اليمنى",
 "left flexor pollicis brevis": "عضلة مثنية قصيرة لإبهام اليد اليسرى",
 "right opponens pollicis": "عضلة مقابلة لإبهام اليد اليمنى",
 "left opponens pollicis": "عضلة مقابلة لإبهام اليد اليسرى",
 "right abductor hallucis": "عضلة مبعدة لإبهام القدم اليمنى",
 "left abductor hallucis": "عضلة مبعدة لإبهام القدم اليسرى",
 "right flexor digitorum brevis": "عضلة مثنية قصيرة للأصابع يمنى",
 "left flexor digitorum brevis": "عضلة مثنية قصيرة للأصابع يسرى",
 "right flexor accessorius": "عضلة مربعة أخمصية يمنى",
 "left flexor accessorius": "عضلة مربعة أخمصية يسرى",
 "right coracobrachialis": "عضلة غرابية عضدية يمنى",
 "left coracobrachialis": "عضلة غرابية عضدية يسرى",
 "right brachialis": "عضلة عضدية يمنى",
 "left brachialis": "عضلة عضدية يسرى",
 "right anconeus": "عضلة مرفقية يمنى",
 "left anconeus": "عضلة مرفقية يسرى",
 "right pronator quadratus": "عضلة كابة مربعة يمنى",
 "left pronator quadratus": "عضلة كابة مربعة يسرى",
 "right flexor carpi radialis": "عضلة مثنية كعبرية للرسغ يمنى",
 "left flexor carpi radialis": "عضلة مثنية كعبرية للرسغ يسرى",
 "right palmaris longus": "عضلة راحية طويلة يمنى",
 "left palmaris longus": "عضلة راحية طويلة يسرى",
 "right flexor digitorum superficialis": "العضلة المثنية السطحية للأصابع اليمنى",
 "left flexor digitorum superficialis": "العضلة المثنية السطحية للأصابع اليسرى",
 "right flexor digitorum profundus": "عضلة مثنية عميقة للأصابع يمنى",
 "left flexor digitorum profundus": "عضلة مثنية عميقة للأصابع يسرى",
 "right flexor pollicis longus": "عضلة مثنية طويلة لإبهام اليد اليمنى",
 "left flexor pollicis longus": "عضلة مثنية طويلة لإبهام اليد اليسرى",
 "right brachioradialis": "عضلة عضدية كعبرية يمنى",
 "left brachioradialis": "عضلة عضدية كعبرية يسرى",
 "right extensor carpi radialis longus": "عضلة كعبرية طويلة باسطة للرسغ يمنى",
 "left extensor carpi radialis longus": "عضلة كعبرية طويلة باسطة للرسغ يسرى",
 "right extensor carpi radialis brevis": "عضلة كعبرية قصيرة باسطة للرسغ يمنى",
 "left extensor carpi radialis brevis": "عضلة كعبرية قصيرة باسطة للرسغ يسرى",
 "right extensor digitorum": "عضلة باسطة للأصابع يمنى",
 "left extensor digitorum": "عضلة باسطة للأصابع يسرى",
 "right extensor digiti minimi": "عضلة باسطة للخنصر يمنى",
 "left extensor digiti minimi": "عضلة باسطة للخنصر يسرى",
 "right extensor carpi ulnaris": "عضلة زندية باسطة للرسغ يمنى",
 "left extensor carpi ulnaris": "عضلة زندية باسطة للرسغ يسرى",
 "right supinator": "عضلة باسطة يمنى",
 "left supinator": "عضلة باسطة يسرى",
 "right abductor pollicis longus": "عضلة طويلة مبعدة لإبهام اليد اليمنى",
 "left abductor pollicis longus": "عضلة طويلة مبعدة لإبهام اليد اليسرى",
 "right extensor pollicis brevis": "عضلة قصيرة مادة لإبهام اليد اليمنى",
 "left extensor pollicis brevis": "عضلة قصيرة مادة لإبهام اليد اليسرى",
 "right extensor pollicis longus": "عضلة طويلة مادة لإبهام اليد اليمنى",
 "left extensor pollicis longus": "عضلة طويلة مادة لإبهام اليد اليسرى",
 "right extensor indicis": "عضلة مخصوصة باسطة للسبابة يمنى",
 "left extensor indicis": "عضلة مخصوصة باسطة للسبابة يسرى",
 "right rectus femoris": "العضلة المستقيمة الفخذية اليمنى",
 "left rectus femoris": "العضلة المستقيمة الفخذية اليسرى",
 "right vastus lateralis": "العضلة المتسعة الوحشية اليمنى",
 "left vastus lateralis": "العضلة المتسعة الوحشية اليسرى",
 "right vastus medialis": "العضلة المتسعة الإنسية اليمنى",
 "left vastus medialis": "العضلة المتسعة الإنسية اليسرى",
 "right vastus intermedius": "العضلة المتسعة المتوسطة اليمنى",
 "left vastus intermedius": "العضلة المتسعة المتوسطة اليسرى",
 "right gracilis": "عضلة رقيقة يمنى",
 "left gracilis": "عضلة رقيقة يسرى",
 "right inferior medial genicular artery": "شريان ركبي سفلي إنسي أيمن",
 "left inferior medial genicular artery": "شريان ركبي سفلي إنسي أيسر",
 "right inferior lateral genicular artery": "شريان ركبي وحشي سفلي أيمن",
 "left inferior lateral genicular artery": "شريان ركبي وحشي سفلي أيسر",
 "right anterior tibial artery": "شريان قصبة الساق الأمامي الأيمن",
 "left anterior tibial artery": "شريان قصبة الساق الأمامي الأيسر",
 "right posterior tibial artery": "شريان قصبة الساق الخلفي الأيمن",
 "left posterior tibial artery": "شريان قصبة الساق الخلفي الأيسر",
 "right anterior tibial recurrent artery": "شريان ظنبوبي راجع أمامي أيمن",
 "left anterior tibial recurrent artery": "شريان ظنبوبي راجع أمامي أيسر",
 "right dorsalis pedis artery": "شريان ظهري للقدم أيمن",
 "left dorsalis pedis artery": "شريان ظهري للقدم أيسر",
 "right medial plantar artery": "شريان أخمصي إنسي أيمن",
 "left medial plantar artery": "شريان أخمصي إنسي أيسر",
 "right lateral plantar artery": "شريان أخمصي وحشي أيمن",
 "left lateral plantar artery": "شريان أخمصي وحشي أيسر",
 "right plantar arch": "القوس الأخمصية الأيمن",
 "left plantar arch": "القوس الأخمصية الأيسر",
 "right long plantar ligament": "الرباط الأخمصي الطويل الأيمن",
 "left long plantar ligament": "الرباط الأخمصي الطويل الأيسر",
 "right popliteal vein": "وريد مأبضي أيمن",
 "left popliteal vein": "وريد مأبضي أيسر",
 "right small saphenous vein": "وريد صافن صغير أيمن",
 "left small saphenous vein": "وريد صافن صغير أيسر",
 "right anterior tibial vein": "وريد ظنبوبي أمامي أيمن",
 "left anterior tibial vein": "وريد ظنبوبي أمامي أيسر",
 "right posterior tibial vein": "وريد ظنبوبي خلفي أيمن",
 "left posterior tibial vein": "وريد ظنبوبي خلفي أيسر",
 "right superficial epigastric vein": "وريد شرسوفي سطحي أيمن",
 "left superficial epigastric vein": "وريد شرسوفي سطحي أيسر",
 "right platysma": "عضلة جلدية للعنق يمنى",
 "left platysma": "عضلة جلدية للعنق يسرى",
 "right stylohyoid": "عضلة إبرية لامية يمنى",
 "left stylohyoid": "عضلة إبرية لامية يسرى",
 "right pubococcygeus": "عضلات كيجل أيمن",
 "left pubococcygeus": "عضلات كيجل أيسر",
 "right digastric": "عضلة ذات بطنين يمنى",
 "left digastric": "عضلة ذات بطنين يسرى",
 "right longus capitis": "العضلة الطويلة الرأسية اليمنى",
 "left longus capitis": "العضلة الطويلة الرأسية اليسرى",
 "right mylohyoid": "عضلة ضرسية لامية يمنى",
 "left mylohyoid": "عضلة ضرسية لامية يسرى",
 "right geniohyoid": "عضلة ذقنية لامية يمنى",
 "left geniohyoid": "عضلة ذقنية لامية يسرى",
 "right coccygeus": "عضلة عصعصية يمنى",
 "left coccygeus": "عضلة عصعصية يسرى",
 "right posterior crico-arytenoid": "عضلة حلقية طرجهالية خلفية يمنى",
 "left posterior crico-arytenoid": "عضلة حلقية طرجهالية خلفية يسرى",
 "right lateral crico-arytenoid": "عضلة حلقية طرجهالية وحشية يمنى",
 "left lateral crico-arytenoid": "عضلة حلقية طرجهالية وحشية يسرى",
 "right oblique arytenoid": "عضلة طرجهالية مائلة يمنى",
 "left oblique arytenoid": "عضلة طرجهالية مائلة يسرى",
 "right thyro-arytenoid": "عضلة درقية طرجهالية يمنى",
 "left thyro-arytenoid": "عضلة درقية طرجهالية يسرى",
 "right vocalis": "العضلة الصوتية اليمنى",
 "left vocalis": "العضلة الصوتية اليسرى",
 "right aryepiglotticus": "عضلة طرجهالية لسان مزمارية يمنى",
 "left aryepiglotticus": "عضلة طرجهالية لسان مزمارية يسرى",
 "right superior pharyngeal constrictor": "عضلة مضيقة بلعومية علوية يمنى",
 "left superior pharyngeal constrictor": "عضلة مضيقة بلعومية علوية يسرى",
 "right inferior pharyngeal constrictor": "عضلة مضيقة بلعومية سفلية يمنى",
 "left inferior pharyngeal constrictor": "عضلة مضيقة بلعومية سفلية يسرى",
 "right stylopharyngeus": "العضلة الإبرية البلعومية اليمنى",
 "left stylopharyngeus": "العضلة الإبرية البلعومية اليسرى",
 "right salpingopharyngeus": "عضلة نفيرية بلعومية يمنى",
 "left salpingopharyngeus": "عضلة نفيرية بلعومية يسرى",
 "right genioglossus": "عضلة ذقنية لسانية يمنى",
 "left genioglossus": "عضلة ذقنية لسانية يسرى",
 "right hyoglossus": "عضلة لامية لسانية يمنى",
 "left hyoglossus": "عضلة لامية لسانية يسرى",
 "right levator veli palatini": "رافعة الشراع الحنكي اليمنى",
 "left levator veli palatini": "رافعة الشراع الحنكي اليسرى",
 "right tensor veli palatini": "العضلة الموترة للحفاف اليمنى",
 "left tensor veli palatini": "العضلة الموترة للحفاف اليسرى",
 "right superior rectus": "عضلة مستقيمة علوية يمنى",
 "left superior rectus": "عضلة مستقيمة علوية يسرى",
 "right inferior rectus": "عضلة مستقيمة سفلية يمنى",
 "left inferior rectus": "عضلة مستقيمة سفلية يسرى",
 "right levator palpebrae superioris": "عضلة رافعة الجفن العلوية اليمنى",
 "left levator palpebrae superioris": "عضلة رافعة الجفن العلوية اليسرى",
 "right inferior oblique": "عضلة مائلة سفلية يمنى",
 "left inferior oblique": "عضلة مائلة سفلية يسرى",
 "right superior oblique": "عضلة مائلة علوية يمنى",
 "left superior oblique": "عضلة مائلة علوية يسرى",
 "right lateral rectus": "عضلة مستقيمة وحشية يمنى",
 "left lateral rectus": "عضلة مستقيمة وحشية يسرى",
 "right medial rectus": "عضلة مستقيمة وسطية يمنى",
 "left medial rectus": "عضلة مستقيمة وسطية يسرى",
 "right common tendinous ring": "الحلقة الوترية المشتركة اليمنى",
 "left common tendinous ring": "الحلقة الوترية المشتركة اليسرى",
 "right ophthalmic artery": "شريان عيني أيمن",
 "left ophthalmic artery": "شريان عيني أيسر",
 "right anterior cerebral artery": "شريان مخي أمامي أيمن",
 "left anterior cerebral artery": "شريان مخي أمامي أيسر",
 "right posterior communicating artery": "شريان مخي موصل خلفي أيمن",
 "left posterior communicating artery": "شريان مخي موصل خلفي أيسر",
 "right anterior choroidal artery": "شريان المشيمية الأمامي الأيمن",
 "left anterior choroidal artery": "شريان المشيمية الأمامي الأيسر",
 "right posterior inferior cerebellar artery": "شريان مخيخي سفلي خلفي أيمن",
 "left posterior inferior cerebellar artery": "شريان مخيخي سفلي خلفي أيسر",
 "right anterior spinal artery": "شريان نخاعي أمامي أيمن",
 "left anterior spinal artery": "شريان نخاعي أمامي أيسر",
 "right superior cerebellar artery": "شريان مخيخي علوي أيمن",
 "left superior cerebellar artery": "شريان مخيخي علوي أيسر",
 "right thalamogeniculate artery": "شريان مهادي ركبي أيمن",
 "left thalamogeniculate artery": "شريان مهادي ركبي أيسر",
 "right suprascapular vein": "الوريد فوق الكتف الأيمن",
 "left suprascapular vein": "الوريد فوق الكتف الأيسر",
 "right optic nerve": "العصب البصري الأيمن",
 "left optic nerve": "العصب البصري الأيسر",
 "right trochlear nerve": "عصب بكري أيمن",
 "left trochlear nerve": "عصب بكري أيسر",
 "right deep femoral vein": "وريد فخذي عميق أيمن",
 "left deep femoral vein": "وريد فخذي عميق أيسر",
 "right ophthalmic nerve": "عصب عيني أيمن",
 "left ophthalmic nerve": "عصب عيني أيسر",
 "right lacrimal nerve": "عصب دمعي أيمن",
 "left lacrimal nerve": "عصب دمعي أيسر",
 "right frontal nerve": "عصب جبهي أيمن",
 "left frontal nerve": "عصب جبهي أيسر",
 "right supratrochlear nerve": "العصب فوق البكرة الأيمن",
 "left supratrochlear nerve": "العصب فوق البكرة الأيسر",
 "right supra-orbital nerve": "عصب فوق الحجاج الأيمن",
 "left supra-orbital nerve": "عصب فوق الحجاج الأيسر",
 "right nasociliary nerve": "عصب أنفي هدبي أيمن",
 "left nasociliary nerve": "عصب أنفي هدبي أيسر",
 "right anterior ethmoidal nerve": "عصب غربالي أمامي أيمن",
 "left anterior ethmoidal nerve": "عصب غربالي أمامي أيسر",
 "right infratrochlear nerve": "العصب تحت البكرة الأيمن",
 "left infratrochlear nerve": "العصب تحت البكرة الأيسر",
 "right posterior ethmoidal nerve": "عصب غربالي خلفي أيمن",
 "left posterior ethmoidal nerve": "عصب غربالي خلفي أيسر",
 "right temporal bone": "عظم صدغي أيمن",
 "left temporal bone": "عظم صدغي أيسر",
 "right parietal bone": "عظم جداري أيمن",
 "left parietal bone": "عظم جداري أيسر",
 "right zygomatic bone": "عظم وجني أيمن",
 "left zygomatic bone": "عظم وجني أيسر",
 "right ciliary ganglion": "عقدة هدبية يمنى",
 "left ciliary ganglion": "عقدة هدبية يسرى",
 "right lacrimal bone": "عظم دمعي أيمن",
 "left lacrimal bone": "عظم دمعي أيسر",
 "right nasal bone": "عظم أنفي أيمن",
 "left nasal bone": "عظم أنفي أيسر",
 "right maxilla": "الفك العلوي الأيمن",
 "left maxilla": "الفك العلوي الأيسر",
 "right palatine bone": "عظم حنكي أيمن",
 "left palatine bone": "عظم حنكي أيسر",
 "right inferior nasal concha": "محارة أنفية سفلية يمنى",
 "left inferior nasal concha": "محارة أنفية سفلية يسرى",
 "right arytenoid cartilage": "الغضروف الطرجهالي الأيمن",
 "left arytenoid cartilage": "الغضروف الطرجهالي الأيسر",
 "right corniculate cartilage": "غضروف قريني أيمن",
 "left corniculate cartilage": "غضروف قريني أيسر",
 "right cuneiform cartilage": "غضروف إسفيني أيمن",
 "left cuneiform cartilage": "غضروف إسفيني أيسر",
 "right thyrohyoid membrane": "غشاء درقي لامي يمنى",
 "left thyrohyoid membrane": "غشاء درقي لامي يسرى",
 "right lateral thyrohyoid ligament": "رباط درقي لامي جانبي أيمن",
 "left lateral thyrohyoid ligament": "رباط درقي لامي جانبي أيسر",
 "right vocal ligament": "الرباط الصوتي الأيمن",
 "left vocal ligament": "الرباط الصوتي الأيسر",
 "right conus elasticus": "المخروط المرن الأيمن",
 "left conus elasticus": "المخروط المرن الأيسر",
 "right pterygomandibular raphe": "رفاء جناحي فكي يمنى",
 "left pterygomandibular raphe": "رفاء جناحي فكي يسرى",
 "right upper second secondary premolar tooth": "ضاحكة ثانية علوية يمنى",
 "right upper first secondary premolar tooth": "ضاحكة أولى علوية يمنى",
 "left upper first secondary premolar tooth": "ضاحكة أولى علوية يسرى",
 "left upper second secondary premolar tooth": "ضاحكة ثانية علوية يسرى",
 "left lower second secondary premolar tooth": "ضاحكة ثانية سفلية يسرى",
 "left lower first secondary premolar tooth": "ضاحكة أولى سفلية يسرى",
 "right lower first secondary premolar tooth": "ضاحكة أولى سفلية يمنى",
 "right lower second secondary premolar tooth": "ضاحكة ثانية سفلية يمنى",
 "right iris": "القزحية اليمنى",
 "left iris": "القزحية اليسرى",
 "right cornea": "القرنية اليمنى",
 "left cornea": "القرنية اليسرى",
 "right lens": "العدسة اليمنى",
 "left lens": "العدسة اليسرى",
 "right sclera": "الصلبة اليمنى",
 "left sclera": "الصلبة اليسرى",
 "right choroid": "مشيمية يمنى",
 "left choroid": "مشيمية يسرى",
 "right corona ciliaris": "جزء متثني أيمن",
 "left corona ciliaris": "جزء متثني أيسر",
 "right iliotibial tract": "سبيل حرقفي ظنبوبي أيمن",
 "left iliotibial tract": "سبيل حرقفي ظنبوبي أيسر",
 "right vitreous body": "جسم زجاجي أيمن",
 "left vitreous body": "جسم زجاجي أيسر",
 "right lacrimal gland": "غدة دمعية يمنى",
 "left lacrimal gland": "غدة دمعية يسرى",
 "right major alar cartilage": "غضروف جناحي كبير أيمن",
 "left major alar cartilage": "غضروف جناحي كبير أيسر",
 "right lateral nasal cartilage": "غضروف أنفي وحشي أيمن",
 "left lateral nasal cartilage": "غضروف أنفي وحشي أيسر",
 "right lacrimal lake": "البحيرة الدمعية اليمنى",
 "left lacrimal lake": "البحيرة الدمعية اليسرى",
 "right lacrimal sac": "كيس الدمع الأيمن",
 "left lacrimal sac": "كيس الدمع الأيسر",
 "right nasolacrimal duct": "قناة أنفية دمعية يمنى",
 "left nasolacrimal duct": "قناة أنفية دمعية يسرى",
 "right lacrimal canaliculus": "قنية دمعية يمنى",
 "left lacrimal canaliculus": "قنية دمعية يسرى",
 "right submandibular gland": "الغدة تحت الفك السفلي اليمنى",
 "left submandibular gland": "الغدة تحت الفك السفلي اليسرى",
 "right sublingual gland": "الغدة تحت اللسان اليمنى",
 "left sublingual gland": "الغدة تحت اللسان اليسرى",
 "right optic tract": "سبيل بصري أيمن",
 "right flexor hallucis longus": "عضلة مثنية طويلة لإبهام القدم اليمنى",
 "left flexor hallucis longus": "عضلة مثنية طويلة لإبهام القدم اليسرى",
 "right flexor digitorum longus": "عضلة مثنية طويلة للأصابع يمنى",
 "left flexor digitorum longus": "عضلة مثنية طويلة للأصابع يسرى",
 "right tibialis posterior": "عضلة ظنبوبية خلفية يمنى",
 "left tibialis posterior": "عضلة ظنبوبية خلفية يسرى",
 "right thoracodorsal artery": "شريان صدري ظهراني أيمن",
 "left thoracodorsal artery": "شريان صدري ظهراني أيسر",
 "left optic tract": "سبيل بصري أيسر",
 "right inferior suprarenal artery": "شريان كظري سفلي أيمن",
 "left inferior suprarenal artery": "شريان كظري سفلي أيسر",
 "right lateral tarsal artery": "الشريان الرصغي الوحشي الأيمن",
 "left lateral tarsal artery": "الشريان الرصغي الوحشي الأيسر",
 "right arcuate artery": "شريان القدم القوسي الأيمن",
 "left arcuate artery": "شريان القدم القوسي الأيسر",
 "right deep plantar artery": "شريان أخمصي غائر أيمن",
 "left deep plantar artery": "شريان أخمصي غائر أيسر",
 "right femoral artery": "شريان فخذي أيمن",
 "left femoral artery": "شريان فخذي أيسر",
 "right lateral thoracic vein": "وريد صدري وحشي أيمن",
 "left lateral thoracic vein": "وريد صدري وحشي أيسر",
 "right stylohyoid ligament": "الرباط الإبري اللامي الأيمن",
 "left stylohyoid ligament": "الرباط الإبري اللامي الأيسر",
 "right superior frontal gyrus": "تلفيف جبهي علوي أيمن",
 "left superior frontal gyrus": "تلفيف جبهي علوي أيسر",
 "right middle frontal gyrus": "التلفيف الجبهي المتوسط الأيمن",
 "left middle frontal gyrus": "التلفيف الجبهي المتوسط الأيسر",
 "right inferior frontal gyrus": "تلفيف جبهي سفلي أيمن",
 "left inferior frontal gyrus": "تلفيف جبهي سفلي أيسر",
 "right precentral gyrus": "تلفيف أمام المركزي الأيمن",
 "left precentral gyrus": "تلفيف أمام المركزي الأيسر",
 "right postcentral gyrus": "تلفيف خلف مركزي أيمن",
 "left postcentral gyrus": "تلفيف خلف مركزي أيسر",
 "right supramarginal gyrus": "تلفيف فوق الهامشي الأيمن",
 "left supramarginal gyrus": "تلفيف فوق الهامشي الأيسر",
 "right angular gyrus": "تلفيف زاوي أيمن",
 "left angular gyrus": "تلفيف زاوي أيسر",
 "right superior parietal lobule": "فصيص جداري علوي أيمن",
 "left superior parietal lobule": "فصيص جداري علوي أيسر",
 "right middle temporal gyrus": "التلفيف الصدغي المتوسط الأيمن",
 "left middle temporal gyrus": "التلفيف الصدغي المتوسط الأيسر",
 "right inferior temporal gyrus": "تلفيف صدغي سفلي أيمن",
 "left inferior temporal gyrus": "تلفيف صدغي سفلي أيسر",
 "right fusiform gyrus": "تلفيف مغزلي أيمن",
 "left fusiform gyrus": "تلفيف مغزلي أيسر",
 "right parahippocampal gyrus": "تلفيف مجاور للحصين أيمن",
 "left parahippocampal gyrus": "تلفيف مجاور للحصين أيسر",
 "right hippocampus": "الحصين الأيمن",
 "left hippocampus": "الحصين الأيسر",
 "right cingulate gyrus": "قشرة حزامية يمنى",
 "left cingulate gyrus": "قشرة حزامية يسرى",
 "right caudate nucleus": "نواة ذنبية يمنى",
 "left caudate nucleus": "نواة ذنبية يسرى",
 "right putamen": "البطامة اليمنى",
 "left putamen": "البطامة اليسرى",
 "right globus pallidus": "كرة شاحبة يمنى",
 "left globus pallidus": "كرة شاحبة يسرى",
 "right amygdala": "لوزة دماغية يمنى",
 "left amygdala": "لوزة دماغية يسرى",
 "right internal capsule": "محفظة غائرة يمنى",
 "left internal capsule": "محفظة غائرة يسرى",
 "right fornix of forebrain": "قبو الدماغ الأيمن",
 "left fornix of forebrain": "قبو الدماغ الأيسر",
 "left stria terminalis": "سطر انتهائي أيسر",
 "right occipital lobe": "فص قذالي أيمن",
 "left occipital lobe": "فص قذالي أيسر",
 "right insula": "فص جزيري أيمن",
 "left insula": "فص جزيري أيسر",
 "right lateral geniculate body": "نواة ركبية وحشية يمنى",
 "left lateral geniculate body": "نواة ركبية وحشية يسرى",
 "right medial geniculate body": "نواة ركبية إنسية يمنى",
 "left medial geniculate body": "نواة ركبية إنسية يسرى",
 "right stria medullaris of thalamus": "سطر نخاعي مهادي أيمن",
 "left stria medullaris of thalamus": "سطر نخاعي مهادي أيسر",
 "right superior colliculus": "أكيمة علوية يمنى",
 "left superior colliculus": "أكيمة علوية يسرى",
 "right inferior colliculus": "أكيمة سفلية يمنى",
 "left inferior colliculus": "أكيمة سفلية يسرى",
 "right popliteal artery": "شريان باطن الركبة الأيمن",
 "left popliteal artery": "شريان باطن الركبة الأيسر",
 "right lateral ventricle": "بطين جانبي أيمن",
 "left lateral ventricle": "بطين جانبي أيسر",
 "right long ciliary nerve": "أعصاب هدبية طويلة أيمن",
 "left long ciliary nerve": "أعصاب هدبية طويلة أيسر",
 "right thalamus": "المهاد الأيمن",
 "left thalamus": "المهاد الأيسر",
 "right calcaneal tendon": "وتر أخيل أيمن",
 "left calcaneal tendon": "وتر أخيل أيسر",
 "right recurrent interosseous artery": "شريان بين العظام راجع أيمن",
 "left recurrent interosseous artery": "شريان بين العظام راجع أيسر",
 "right lower limb": "ساق الإنسان الأيمن",
 "left lower limb": "ساق الإنسان الأيسر",
 "left lung": "رئة يسرى",
 "nipple (left)": "الحلمة اليسرى",
 "areola (left)": "هالة الثدي اليسرى",
 "mammary lobes (left)": "فصوص الثدي الأيسر",
 "main lactiferous ducts (left)": "القنوات اللبنية الأيسر",
 "mammary gland (left)": "الغدة الثديية اليسرى",
 "nipple (right)": "الحلمة اليمنى",
 "areola (right)": "هالة الثدي اليمنى",
 "main lactiferous ducts (right)": "القنوات اللبنية الأيمن",
 "mammary lobes (right)": "فصوص الثدي الأيمن",
 "mammary gland (right)": "الغدة الثديية اليمنى",
 "fovea (right)": "النقرة المركزية اليمنى",
 "macula lutea (right)": "اللطخة الصفراء اليمنى",
 "optic disc (right)": "القرص البصري الأيمن",
 "retina (right)": "الشبكية اليمنى",
 "sclera (right)": "الصلبة اليمنى",
 "optic choroid (right)": "المشيمية اليمنى",
 "pupil (right)": "البؤبؤ الأيمن",
 "suspensory ligament of lens (right)": "نطيفة هدبية يمنى",
 "ora serrata of retina (right)": "الحافة المسننة للشبكية اليمنى",
 "lens (right)": "العدسة اليمنى",
 "aqueous humor (right)": "الخلط المائي الأيمن",
 "ciliary body (right)": "الجسم الهدبي الأيمن",
 "trabecular meshwork (right)": "الشبكة التربيقية اليمنى",
 "iris (right)": "القزحية اليمنى",
 "bulbar conjunctiva (right)": "الملتحمة المقلية اليمنى",
 "cornea (right)": "القرنية اليمنى",
 "vitreous humor (right)": "الخلط الزجاجي الأيمن",
 "eye (right)": "العين الأيمن",
 "fovea (left)": "النقرة المركزية اليسرى",
 "macula lutea (left)": "اللطخة الصفراء اليسرى",
 "optic disc (left)": "القرص البصري الأيسر",
 "retina (left)": "الشبكية اليسرى",
 "vitreous humor (left)": "الخلط الزجاجي الأيسر",
 "cornea (left)": "القرنية اليسرى",
 "bulbar conjunctiva (left)": "الملتحمة المقلية اليسرى",
 "iris (left)": "القزحية اليسرى",
 "trabecular meshwork (left)": "الشبكة التربيقية اليسرى",
 "ciliary body (left)": "الجسم الهدبي الأيسر",
 "aqueous humor (left)": "الخلط المائي الأيسر",
 "lens (left)": "العدسة اليسرى",
 "ora serrata of retina (left)": "الحافة المسننة للشبكية اليسرى",
 "suspensory ligament of lens (left)": "نطيفة هدبية يسرى",
 "pupil (left)": "البؤبؤ الأيسر",
 "optic choroid (left)": "المشيمية اليسرى",
 "sclera (left)": "الصلبة اليسرى",
 "eye (left)": "العين الأيسر",
 "olfactory bulb (left)": "البصلة الشمية اليسرى",
 "putamen (left)": "البطامة اليسرى",
 "claustrum (left)": "السياج الأيسر",
 "amygdaloid complex (left)": "المجمع اللوزي الأيسر",
 "thalamus (left)": "المهاد الأيسر",
 "pineal body (left)": "غدة صنوبرية يسرى",
 "anterior commissure (left)": "صوار أمامي أيسر",
 "corpus callosum (left)": "الجسم الثفني الأيسر",
 "fornix (left)": "القبو الأيسر",
 "optic tract (left)": "سبيل بصري أيسر",
 "cerebellar vermis (left)": "دودة المخيخ اليسرى",
 "superior frontal gyrus (left)": "تلفيف جبهي علوي أيسر",
 "middle frontal gyrus (left)": "التلفيف الجبهي المتوسط الأيسر",
 "postcentral gyrus (left)": "تلفيف خلف مركزي أيسر",
 "supramarginal gyrus (left)": "تلفيف فوق الهامشي الأيسر",
 "angular gyrus (left)": "تلفيف زاوي أيسر",
 "middle temporal gyrus (left)": "التلفيف الصدغي المتوسط الأيسر",
 "inferior temporal gyrus (left)": "تلفيف صدغي سفلي أيسر",
 "substantia nigra (left)": "المادة السوداء اليسرى",
 "superior colliculus (left)": "أكيمة علوية يسرى",
 "cerebral aqueduct (left)": "مسال دماغي أيسر",
 "hippocampus (left)": "الحصين الأيسر",
 "brain hemisphere (left)": "نصف الكرة المخية الأيسر",
 "olfactory bulb (right)": "البصلة الشمية اليمنى",
 "putamen (right)": "البطامة اليمنى",
 "claustrum (right)": "السياج الأيمن",
 "amygdaloid complex (right)": "المجمع اللوزي الأيمن",
 "thalamus (right)": "المهاد الأيمن",
 "pineal body (right)": "غدة صنوبرية يمنى",
 "anterior commissure (right)": "صوار أمامي أيمن",
 "corpus callosum (right)": "الجسم الثفني الأيمن",
 "fornix (right)": "القبو الأيمن",
 "optic tract (right)": "سبيل بصري أيمن",
 "cerebellar vermis (right)": "دودة المخيخ اليمنى",
 "superior frontal gyrus (right)": "تلفيف جبهي علوي أيمن",
 "middle frontal gyrus (right)": "التلفيف الجبهي المتوسط الأيمن",
 "postcentral gyrus (right)": "تلفيف خلف مركزي أيمن",
 "supramarginal gyrus (right)": "تلفيف فوق الهامشي الأيمن",
 "angular gyrus (right)": "تلفيف زاوي أيمن",
 "middle temporal gyrus (right)": "التلفيف الصدغي المتوسط الأيمن",
 "inferior temporal gyrus (right)": "تلفيف صدغي سفلي أيمن",
 "substantia nigra (right)": "المادة السوداء اليمنى",
 "superior colliculus (right)": "أكيمة علوية يمنى",
 "inferior colliculus (right)": "أكيمة سفلية يمنى",
 "cerebral aqueduct (right)": "مسال دماغي أيمن",
 "hypothalamus (left)": "الوطاء اليسرى",
 "hypothalamus (right)": "الوطاء اليمنى",
 "inferior colliculus (left)": "أكيمة سفلية يسرى",
 "hippocampus (right)": "الحصين الأيمن",
 "brain hemisphere (right)": "نصف الكرة المخية الأيمن",
 "rectus femoris (left)": "العضلة المستقيمة الفخذية اليسرى",
 "rectus femoris (right)": "العضلة المستقيمة الفخذية اليمنى",
 "umbilical artery 1": "الشريان السري الأول",
 "umbilical artery 2": "الشريان السري الثاني",
 "fimbriae of uterine tube (right)": "أهداب البوق الأيمن",
 "fallopian tube (right)": "قناة فالوب يمنى",
 "fimbriae of uterine tube (left)": "أهداب البوق الأيسر",
 "fallopian tube (left)": "قناة فالوب يسرى",
 "right round ligament of uterus": "الرباط المدور للرحم الأيمن",
 "left round ligament of uterus": "الرباط المدور للرحم الأيسر",
 "right uterosacral ligament": "الرباط الرحمي العجزي الأيمن",
 "left uterosacral ligament": "الرباط الرحمي العجزي الأيسر",
 "right cardinal ligament of uterus": "الرباط الأساسي للرحم الأيمن",
 "left cardinal ligament of uterus": "الرباط الأساسي للرحم الأيسر",
 "suspensory ligament of ovary (right)": "الرباط المعلق للمبيض الأيمن",
 "suspensory ligament of ovary (left)": "الرباط المعلق للمبيض الأيسر",
 "ovarian ligament (left)": "رباط المبيض الأيسر",
 "ovarian ligament (right)": "رباط المبيض الأيمن",
 "mesosalpinx (left)": "مساريق البوق الأيسر",
 "mesosalpinx (right)": "مساريق البوق الأيمن",
 "mesovarium (right)": "مساريق المبيض الأيمن",
 "mesovarium (left)": "مساريق المبيض الأيسر",
 "left ovary": "المبيض الأيسر",
 "right ovary": "المبيض الأيمن",
 "submandibular gland (left)": "الغدة تحت الفك السفلي اليسرى",
 "submandibular gland (right)": "الغدة تحت الفك السفلي اليمنى",
 "parotid gland (right)": "الغدة النكفية اليمنى",
 "parotid gland (left)": "الغدة النكفية اليسرى",
 "sublingual gland (right)": "الغدة تحت اللسان اليمنى",
 "sublingual gland (left)": "الغدة تحت اللسان اليسرى",
 "palatine tonsil (left)": "اللوزة الحنكية اليسرى",
 "palatine tonsil (right)": "اللوزة الحنكية اليمنى",
 "renal papilla (left)": "الحليمة الكلوية اليسرى",
 "renal pyramid (left)": "الهرم الكلوي الأيسر",
 "renal medulla (left)": "لب الكلية الأيسر",
 "renal column (left)": "العمود الكلوي الأيسر",
 "outer cortex of kidney (left)": "قشرة الكلية اليسرى",
 "outer cortex of kidney (right)": "قشرة الكلية اليمنى",
 "renal column (right)": "العمود الكلوي الأيمن",
 "renal papilla (right)": "الحليمة الكلوية اليمنى",
 "renal pyramid (right)": "الهرم الكلوي الأيمن",
 "renal medulla (right)": "لب الكلية الأيمن",
 "minor calyx (right)": "الكأس الكلوي الصغير الأيمن",
 "major calyx (right)": "الكأس الكلوي الكبير الأيمن",
 "renal pelvis (right)": "حويضة الكلية اليمنى",
 "minor calyx (left)": "الكأس الكلوي الصغير الأيسر",
 "major calyx (left)": "الكأس الكلوي الكبير الأيسر",
 "renal pelvis (left)": "حويضة الكلية اليسرى",
 "ophthalmic artery (left)": "شريان عيني أيسر",
 "ophthalmic artery (right)": "شريان عيني أيمن",
 "internal iliac vein (left)": "وريد حرقفي غائر أيسر",
 "internal iliac vein (right)": "وريد حرقفي غائر أيمن",
 "internal pudendal vein (left)": "وريد فرجي غائر أيسر",
 "internal pudendal vein (right)": "وريد فرجي غائر أيمن",
 "pulmonary artery (left)": "جذع رئوي أيسر",
 "pulmonary artery (right)": "جذع رئوي أيمن",
 "lungs (right)": "الرئتان الأيمن",
 "arytenoid cartilage (right)": "الغضروف الطرجهالي الأيمن",
 "arytenoid cartilage (left)": "الغضروف الطرجهالي الأيسر",
 "corniculate cartilage (left)": "غضروف قريني أيسر",
 "corniculate cartilage (right)": "غضروف قريني أيمن",
 "bronchi (left)": "القصبات الأيسر",
 "bronchi (right)": "القصبات الأيمن",
 "thymus lobe (left)": "فص التوتة الأيسر",
 "thymus lobe (right)": "فص التوتة الأيمن",
 "thoracic vertebra 1": "الفقرة الصدرية الأولى",
 "thoracic vertebra 2": "الفقرة الصدرية الثانية",
 "thoracic vertebra 3": "الفقرة الصدرية الثالثة",
 "thoracic vertebra 4": "الفقرة الصدرية الرابعة",
 "thoracic vertebra 5": "الفقرة الصدرية الخامسة",
 "thoracic vertebra 6": "الفقرة الصدرية السادسة",
 "thoracic vertebra 7": "الفقرة الصدرية السابعة",
 "thoracic vertebra 8": "الفقرة الصدرية الثامنة",
 "thoracic vertebra 9": "الفقرة الصدرية التاسعة",
 "thoracic vertebra 10": "الفقرة الصدرية العاشرة",
 "thoracic vertebra 11": "الفقرة الصدرية الحادية عشرة",
 "thoracic vertebra 12": "الفقرة الصدرية الثانية عشرة",
 "cervical vertebra 1": "الفقرة العنقية الأولى",
 "cervical vertebra 2": "الفقرة العنقية الثانية",
 "cervical vertebra 3": "الفقرة العنقية الثالثة",
 "cervical vertebra 4": "الفقرة العنقية الرابعة",
 "cervical vertebra 5": "الفقرة العنقية الخامسة",
 "cervical vertebra 6": "الفقرة العنقية السادسة",
 "cervical vertebra 7": "الفقرة العنقية السابعة",
 "lumbar vertebra 6": "الفقرة القطنية السادسة",
 "lumbar vertebra 5": "الفقرة القطنية الخامسة",
 "lumbar vertebra 4": "الفقرة القطنية الرابعة",
 "lumbar vertebra 3": "الفقرة القطنية الثالثة",
 "lumbar vertebra 2": "الفقرة القطنية الثانية",
 "lumbar vertebra 1": "الفقرة القطنية الأولى",
 "anterior cruciate ligament of knee (right)": "الرباط الصليبي الأمامي الأيمن",
 "posterior cruciate ligament of knee (right)": "الرباط الصليبي الخلفي الأيمن",
 "fibular collateral ligament (right)": "الرباط الجانبي الشظوي الأيمن",
 "patellar ligament (right)": "الرباط الرضفي الأيمن",
 "meniscus (right)": "الغضروف الهلالي الأيمن",
 "articular cartilage of knee (right)": "الغضروف المفصلي للركبة الأيمن",
 "femur (right)": "عظم الفخذ الأيمن",
 "tibia (right)": "عظم الظنبوب الأيمن",
 "fibula (right)": "عظم الشظية الأيمن",
 "patella (right)": "الرضفة اليمنى",
 "knee joint (right)": "مفصل الركبة الأيمن",
 "lower limb (right)": "ساق الإنسان الأيمن",
 "fibular collateral ligament (left)": "الرباط الجانبي الشظوي الأيسر",
 "patellar ligament (left)": "الرباط الرضفي الأيسر",
 "anterior cruciate ligament of knee (left)": "الرباط الصليبي الأمامي الأيسر",
 "posterior cruciate ligament of knee (left)": "الرباط الصليبي الخلفي الأيسر",
 "meniscus (left)": "الغضروف الهلالي الأيسر",
 "articular cartilage of knee (left)": "الغضروف المفصلي للركبة الأيسر",
 "femur (left)": "عظم الفخذ الأيسر",
 "patella (left)": "الرضفة اليسرى",
 "tibia (left)": "عظم الظنبوب الأيسر",
 "fibula (left)": "عظم الشظية الأيسر",
 "knee joint (left)": "مفصل الركبة الأيسر",
 "lower limb (left)": "ساق الإنسان الأيسر",
 "adductor brevis (left)": "عضلة مقربة قصيرة يسرى",
 "adductor longus (left)": "عضلة مقربة طويلة يسرى",
 "adductor magnus (left)": "عضلة مقربة كبيرة يسرى",
 "biceps femoris long (left)": "الرأس الطويل للعضلة ذات الرأسين الفخذية الأيسر",
 "biceps femoris short (left)": "الرأس القصير للعضلة ذات الرأسين الفخذية الأيسر",
 "gastrocnemius medial (left)": "الرأس الإنسي للعضلة التوأمية الساقية الأيسر",
 "gracilis (left)": "عضلة رقيقة يسرى",
 "plantaris (left)": "عضلة أخمصية يسرى",
 "popliteus (left)": "عضلة مأبضية يسرى",
 "sartorius (left)": "عضلة خياطية يسرى",
 "semimembranosus (left)": "عضلة نصف غشائية يسرى",
 "semitendinosus (left)": "عضلة نصف وترية يسرى",
 "vastus intermedius (left)": "العضلة المتسعة المتوسطة اليسرى",
 "vastus lateralis (left)": "العضلة المتسعة الوحشية اليسرى",
 "vastus medialis (left)": "العضلة المتسعة الإنسية اليسرى",
 "extensor digitorum longus (left)": "عضلة طويلة باسطة لأصابع القدم اليسرى",
 "extensor hallucis longus (left)": "عضلة طويلة باسطة لإبهام القدم اليسرى",
 "flexor digitorum longus (left)": "عضلة مثنية طويلة للأصابع يسرى",
 "flexor hallucis longus (left)": "عضلة مثنية طويلة لإبهام القدم اليسرى",
 "gastrocnemius lateral (left)": "الرأس الوحشي للعضلة التوأمية الساقية الأيسر",
 "peroneus longus (left)": "العضلة الشظوية الطويلة اليسرى",
 "soleus (left)": "عضلة نعلية يسرى",
 "tibialis anterior (left)": "عضلة ظنبوبية أمامية يسرى",
 "tibialis posterior (left)": "عضلة ظنبوبية خلفية يسرى",
 "gluteus maximus (left)": "عضلة ألوية كبرى يسرى",
 "gluteus medius (left)": "عضلة ألوية وسطى يسرى",
 "gluteus minimus (left)": "عضلة ألوية صغرى يسرى",
 "iliacus (left)": "عضلة حرقفية يسرى",
 "inferior gemellus (left)": "العضلة التوأمية السفلية اليسرى",
 "obturator externus (left)": "عضلة سدادية خارجية يسرى",
 "obturator internus (left)": "عضلة سدادية غائرة يسرى",
 "pectineus (left)": "عضلة عانية يسرى",
 "piriformis (left)": "عضلة كمثرية يسرى",
 "psoas major (left)": "عضلة قطنية كبيرة يسرى",
 "quadratus femoris (left)": "عضلة مربعة فخذية يسرى",
 "superior gemellus (left)": "العضلة التوأمية العلوية اليسرى",
 "tensor fasciae latae (left)": "عضلة موترة للفافة العريضة اليسرى",
 "adductor brevis (right)": "عضلة مقربة قصيرة يمنى",
 "adductor longus (right)": "عضلة مقربة طويلة يمنى",
 "adductor magnus (right)": "عضلة مقربة كبيرة يمنى",
 "gastrocnemius medial (right)": "الرأس الإنسي للعضلة التوأمية الساقية الأيمن",
 "gracilis (right)": "عضلة رقيقة يمنى",
 "plantaris (right)": "عضلة أخمصية يمنى",
 "popliteus (right)": "عضلة مأبضية يمنى",
 "sartorius (right)": "عضلة خياطية يمنى",
 "semimembranosus (right)": "عضلة نصف غشائية يمنى",
 "semitendinosus (right)": "عضلة نصف وترية يمنى",
 "vastus intermedius (right)": "العضلة المتسعة المتوسطة اليمنى",
 "vastus lateralis (right)": "العضلة المتسعة الوحشية اليمنى",
 "vastus medialis (right)": "العضلة المتسعة الإنسية اليمنى",
 "extensor digitorum longus (right)": "عضلة طويلة باسطة لأصابع القدم اليمنى",
 "extensor hallucis longus (right)": "عضلة طويلة باسطة لإبهام القدم اليمنى",
 "flexor digitorum longus (right)": "عضلة مثنية طويلة للأصابع يمنى",
 "flexor hallucis longus (right)": "عضلة مثنية طويلة لإبهام القدم اليمنى",
 "gastrocnemius lateral (right)": "الرأس الوحشي للعضلة التوأمية الساقية الأيمن",
 "peroneus longus (right)": "العضلة الشظوية الطويلة اليمنى",
 "soleus (right)": "عضلة نعلية يمنى",
 "tibialis anterior (right)": "عضلة ظنبوبية أمامية يمنى",
 "tibialis posterior (right)": "عضلة ظنبوبية خلفية يمنى",
 "gluteus maximus (right)": "عضلة ألوية كبرى يمنى",
 "gluteus medius (right)": "عضلة ألوية وسطى يمنى",
 "gluteus minimus (right)": "عضلة ألوية صغرى يمنى",
 "iliacus (right)": "عضلة حرقفية يمنى",
 "inferior gemellus (right)": "العضلة التوأمية السفلية اليمنى",
 "obturator externus (right)": "عضلة سدادية خارجية يمنى",
 "obturator internus (right)": "عضلة سدادية غائرة يمنى",
 "pectineus (right)": "عضلة عانية يمنى",
 "piriformis (right)": "عضلة كمثرية يمنى",
 "psoas major (right)": "عضلة قطنية كبيرة يمنى",
 "quadratus femoris (right)": "عضلة مربعة فخذية يمنى",
 "superior gemellus (right)": "العضلة التوأمية العلوية اليمنى",
 "tensor fasciae latae (right)": "عضلة موترة للفافة العريضة اليمنى"
}